
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2EvGI", function(module, exports) {

parcelRequire("l0YXi");




// Need to disable this because this affects how files are bundled together
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $a31afb015eeeb9c8$var$lazyImports = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("3fQGY"));
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("fb5Sn"));
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("hu0G4"));
};
// We set this global variable to ensure it is available to all environments
// and then overwrite its value to TRUE in the JiraSPA entries: SSR and non-SSR
$parcel$global.__SPA__ = false;

});
parcelRegister("l0YXi", function(module, exports) {

var $8xmdY = parcelRequire("8xmdY");

var $1ybV0 = parcelRequire("1ybV0");

var $bIHey = parcelRequire("bIHey");
// eslint-disable-next-line jira/ff/no-module-level-eval
const $dd5528522e8f05f9$var$isErrorTrackingEnabledWithSentry = (0, $1ybV0.ff)('fe.platform.error.tracking.enabled');
if ($dd5528522e8f05f9$var$isErrorTrackingEnabledWithSentry) (0, $8xmdY.installGlobalHandler)();
(0, $bIHey.default)();

});

parcelRegister("3fQGY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "AnalyticsProviders", () => $0f49408e4b712ba4$export$fe99df39f319f93e);
$parcel$export(module.exports, "default", () => $0f49408e4b712ba4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $8WuJm = parcelRequire("8WuJm");

var $3DOEL = parcelRequire("3DOEL");

var $jD3pk = parcelRequire("jD3pk");

var $2B87Z = parcelRequire("2B87Z");

var $gd0Sp = parcelRequire("gd0Sp");

var $dfiLi = parcelRequire("dfiLi");

var $3gru2 = parcelRequire("3gru2");
const $0f49408e4b712ba4$export$fe99df39f319f93e = ({ children: children })=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    (0, $eUqFw.useEffect)(()=>{
        if (false) return;
        try {
            const success = (0, $2B87Z.measureInitialPageLoadTiming)(`analytics-providers/init-analytics${(0, $3DOEL.getAnalyticsWebClient)() ? '' : ':initial'}`, ()=>(0, $dfiLi.default)({
                    ...tenantContext,
                    orgId: orgId
                }));
            if (success === undefined) throw new Error('observability.analytics-providers-error: @atlassiansox/analytics-web-client AnalyticsClient in src/common/analytics-web-react/web-client/index.js failed to initialise successfully');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('observability.analytics-providers.analytics', e);
        }
    }, [
        orgId,
        tenantContext
    ]);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3gru2.JiraStructuredAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: {
            isSPA: __SPA__,
            variant: window.BUILD_VARIANT
        }
    }, children));
};
var $0f49408e4b712ba4$export$2e2bcd8739ae039 = $0f49408e4b712ba4$export$fe99df39f319f93e;

});
parcelRegister("8WuJm", function(module, exports) {

$parcel$export(module.exports, "ContextualAnalyticsData", () => $3c263ef766c6cdcb$export$198470770171c65);
/**
 * This library is the only place where you'd use raw AnalyticsContext
 * It provides a typed wrapper around it for better user experience
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $kkgbD = parcelRequire("kkgbD");

var $i7Fym = parcelRequire("i7Fym");

var $aw5Sy = parcelRequire("aw5Sy");
const $3c263ef766c6cdcb$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD))));
};
const $3c263ef766c6cdcb$export$198470770171c65 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const data = $3c263ef766c6cdcb$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children));
}); /* eslint-enable react/require-default-props */ 

});

parcelRegister("jD3pk", function(module, exports) {

$parcel$export(module.exports, "organizationIdResource", () => $309149c00e873aac$export$f29c789c312dea01);
$parcel$export(module.exports, "useOrgId", () => $309149c00e873aac$export$52a03a3207af3687);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $hqVLk = parcelRequire("hqVLk");

var $gAogs = parcelRequire("gAogs");
const $309149c00e873aac$var$fetchOrganizationId = async (cloudId)=>{
    const result = await (0, $2OdyW.default)('/gateway/api/graphql', {
        method: 'POST',
        body: JSON.stringify({
            query: `
                query OrganizationId($cloudIds: [ID!]) {
                    tenantContexts(cloudIds: $cloudIds) {
                        orgId
                    }
                }
            `,
            variables: {
                cloudIds: [
                    cloudId
                ]
            }
        })
    });
    return result?.data?.tenantContexts?.[0]?.orgId || null;
};
const $309149c00e873aac$var$errorMeta = {
    id: 'organizationId',
    packageName: 'jiraNavigationAppsResources'
};
const $309149c00e873aac$export$f29c789c312dea01 = (0, $hqVLk.createResource)({
    type: 'ORGANIZATION_ID',
    getKey: ()=>'teamOrgState',
    getData: async (_, { tenantContext: { cloudId: cloudId } })=>{
        try {
            const orgId = await $309149c00e873aac$var$fetchOrganizationId(cloudId);
            if (typeof orgId !== 'string' || !orgId || orgId.length < 1) (0, $guiFP.default)({
                meta: $309149c00e873aac$var$errorMeta,
                attributes: {
                    hasCloudId: Boolean(cloudId),
                    value: String(orgId),
                    problem: 'bad-org-id-fetched'
                }
            });
            return orgId;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: $309149c00e873aac$var$errorMeta,
                error: error,
                attributes: {
                    hasCloudId: Boolean(cloudId),
                    value: 'null',
                    problem: 'load-failed'
                }
            });
            return null;
        }
    },
    isBrowserOnly: true
});
const $309149c00e873aac$export$52a03a3207af3687 = ()=>{
    const { data: data } = (0, $hqVLk.useResource)($309149c00e873aac$export$f29c789c312dea01);
    const [savedOrg, updateOrg] = (0, $gAogs.useSavedOrgId)();
    (0, $eUqFw.useEffect)(()=>{
        if (data) updateOrg(data);
    }, [
        data,
        updateOrg
    ]);
    return {
        data: data || savedOrg || undefined
    };
};

});
parcelRegister("2OdyW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d009905f540e56e$export$2e2bcd8739ae039);

var $6HC1D = parcelRequire("6HC1D");

var $fVqUX = parcelRequire("fVqUX");

var $7byHA = parcelRequire("7byHA");

var $bH2vr = parcelRequire("bH2vr");

var $etaBp = parcelRequire("etaBp");

var $jxATW = parcelRequire("jxATW");
var /**
 * Fetch from the given URL, returning the json response.
 * <p>
 * If there are any HTTP errors the promise is rejected with a {@link FetchError}.
 *
 * @param {string} url - to fetch the JSON from
 * @param {object} options - for the fetch call
 * @returns promise containing the JSON
 * @throws {@link FetchError} if there was an HTTP Error. This will reject the promise.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$6d009905f540e56e$export$2e2bcd8739ae039 = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, (0, $6HC1D.merge)((0, $fVqUX.default), options))).then((response)=>{
        if (!response.ok) {
            const traceId = (0, $jxATW.getTraceId)(response);
            if (traceId !== undefined && traceId.length > 0) throw new (0, $7byHA.default)(response.status, `Fetch call failed with status code: ${response.status}`, traceId, response);
            else throw new (0, $7byHA.default)(response.status, undefined, undefined, response);
        }
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return response.json();
    });

});
parcelRegister("bH2vr", function(module, exports) {

$parcel$export(module.exports, "getReroutableURL", () => $42b3ac3411bbe7a0$export$23769875e8eebaf6);
const $42b3ac3411bbe7a0$var$LOCAL_URL = new URL('http://localhost:9000');
function $42b3ac3411bbe7a0$export$23769875e8eebaf6(pathOrURL) {
    var e;
    return pathOrURL;
}

});

parcelRegister("etaBp", function(module, exports) {

$parcel$export(module.exports, "makeObservabilityHeaders", () => $6a6186714cad484d$export$78a090c6aabf87d6);
$parcel$export(module.exports, "applyObservabilityHeaders", () => $6a6186714cad484d$export$f51f2ccd07af96d8);

var $k4nIh = parcelRequire("k4nIh");

var $gXgRp = parcelRequire("gXgRp");

var $1qnta = parcelRequire("1qnta");
const $6a6186714cad484d$export$78a090c6aabf87d6 = (url)=>{
    const headers = {};
    const capability = (0, $gXgRp.getCapability)();
    if (capability !== null) headers[0, $d07297a4af13004b$export$9a80695e72849f84] = capability;
    const tracingHeaders = (0, $1qnta.getActiveTraceHttpRequestHeaders)(url);
    if (tracingHeaders !== null) Object.assign(headers, tracingHeaders);
    if (Object.keys(headers).length === 0) return null;
    return {
        headers: headers
    };
};
const $6a6186714cad484d$export$f51f2ccd07af96d8 = (url, options)=>{
    const endpointUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url);
    if (!false && endpointUrl.hostname && endpointUrl.hostname !== window.location.hostname) return options;
    const extraHeaders = $6a6186714cad484d$export$78a090c6aabf87d6(url);
    if (extraHeaders === null) return options;
    return {
        ...options,
        headers: {
            ...options.headers,
            ...extraHeaders.headers
        }
    };
};

});
const $d07297a4af13004b$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $d07297a4af13004b$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $d07297a4af13004b$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $d07297a4af13004b$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $d07297a4af13004b$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $d07297a4af13004b$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $d07297a4af13004b$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $d07297a4af13004b$export$6d592df97fba16ca = 'GIN_GLOBAL_ISSUE_NAVIGATOR';
const $d07297a4af13004b$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $d07297a4af13004b$export$4695c1a423ffe431 = 'DASHBOARD';
const $d07297a4af13004b$export$4ce203fc8c0eb2d1 = 'ISSUE_MOVE';
const $d07297a4af13004b$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
const $d07297a4af13004b$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("gXgRp", function(module, exports) {

$parcel$export(module.exports, "setCapability", () => $4a4e33c4678444ae$export$60e3f676689faf78);
$parcel$export(module.exports, "getCapability", () => $4a4e33c4678444ae$export$38805c31c710553c);
let $4a4e33c4678444ae$var$activeCapability = null;
const $4a4e33c4678444ae$export$60e3f676689faf78 = (capability)=>{
    $4a4e33c4678444ae$var$activeCapability = capability;
};
const $4a4e33c4678444ae$export$38805c31c710553c = ()=>$4a4e33c4678444ae$var$activeCapability;

});


parcelRegister("jxATW", function(module, exports) {

$parcel$export(module.exports, "getTraceId", () => $23e533f2ea266415$export$e88cb5bfb57ce9c4);
$parcel$export(module.exports, "getTraceIdJq", () => $23e533f2ea266415$export$b569b31eebca952d);

var $88Osm = parcelRequire("88Osm");
const $23e533f2ea266415$export$e88cb5bfb57ce9c4 = (response)=>{
    const traceIdHeader = (0, $88Osm.KNOWN_TRACE_ID_HEADERS).find((header)=>response.headers.has(header));
    return traceIdHeader === undefined ? undefined : response.headers.get(traceIdHeader) ?? undefined;
};
const $23e533f2ea266415$export$b569b31eebca952d = (jqxhr)=>{
    if (!jqxhr || !jqxhr.getResponseHeader) // prefer a silent fail, so we don't accidentally swallow the original error being built
    return undefined;
    const traceIdHeader = (0, $88Osm.KNOWN_TRACE_ID_HEADERS).find((header)=>jqxhr.getResponseHeader(header) != null);
    return traceIdHeader === undefined ? undefined : jqxhr.getResponseHeader(traceIdHeader);
};

});
parcelRegister("88Osm", function(module, exports) {

$parcel$export(module.exports, "TRACE_ID_HEADER", () => $cceb03b40a2d9a37$export$4b69438fb7c7b9b2);
$parcel$export(module.exports, "KNOWN_TRACE_ID_HEADERS", () => $cceb03b40a2d9a37$export$830a89e935012abe);
const $cceb03b40a2d9a37$export$4b69438fb7c7b9b2 = 'atl-traceid';
const $cceb03b40a2d9a37$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
const $cceb03b40a2d9a37$export$830a89e935012abe = [
    $cceb03b40a2d9a37$export$4b69438fb7c7b9b2,
    $cceb03b40a2d9a37$var$TRACE_ID_HEADER_MICROS
];

});



parcelRegister("gAogs", function(module, exports) {

$parcel$export(module.exports, "useSavedOrgId", () => $c9c91297889c5973$export$565a2d780e27e46e);

var $eUqFw = parcelRequire("eUqFw");
const $c9c91297889c5973$var$ORG_ID_STORAGE_KEY = 'this_site_organization_id';
const $c9c91297889c5973$export$458a92a6364e5c62 = ()=>{
    if (false) return null;
    const item = window.localStorage?.getItem($c9c91297889c5973$var$ORG_ID_STORAGE_KEY);
    return item;
};
const $c9c91297889c5973$export$ec13c725e067146a = (orgId)=>{
    try {
        window.localStorage?.setItem($c9c91297889c5973$var$ORG_ID_STORAGE_KEY, orgId);
    } catch  {
    // Do nothing
    }
};
const $c9c91297889c5973$export$565a2d780e27e46e = ()=>{
    const savedOrgId = (0, $eUqFw.useMemo)($c9c91297889c5973$export$458a92a6364e5c62, []);
    return [
        savedOrgId,
        $c9c91297889c5973$export$ec13c725e067146a
    ];
};

});


parcelRegister("2B87Z", function(module, exports) {

$parcel$export(module.exports, "setInitialPageLoadTimingFromPerformanceMarks", () => $992d482032b2bb0b$export$15ca6669ae356831);
$parcel$export(module.exports, "stopInitialPageLoadTimingFromPerformanceMarkStart", () => $992d482032b2bb0b$export$ab75d59423c060f4);
$parcel$export(module.exports, "measureInitialPageLoadTiming", () => $992d482032b2bb0b$export$e18462760bac553c);
$parcel$export(module.exports, "setProductBundleReadyForInitialRender", () => $992d482032b2bb0b$export$de1b4cf109d9ab65);

var $acbV3 = parcelRequire("acbV3");

var $5pGvH = parcelRequire("5pGvH");
/**
 * `performance.measure` will throw if start/stop aren't set.
 *
 * This call sets a user-timing on the profiler timelines so we can see sections of the load.
 */ const $992d482032b2bb0b$var$safeMeasure = (name, start, stop)=>{
    try {
        performance.measure(name, start, stop);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
    } catch (_err) {}
};
const $992d482032b2bb0b$export$15ca6669ae356831 = (name, start, stop, cleanStart = false, cleanStop = false)=>{
    if (false) return;
    $992d482032b2bb0b$var$safeMeasure(name, start, stop);
    (0, $acbV3.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stop);
    (0, $5pGvH.addTimingFromPerformanceMark)(name, start, stop, cleanStart, cleanStop);
};
const $992d482032b2bb0b$export$ab75d59423c060f4 = (name, start, cleanStart = false)=>{
    if (false) return;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(stopMark);
    $992d482032b2bb0b$var$safeMeasure(name, start, stopMark);
    (0, $acbV3.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, start, stopMark);
    (0, $5pGvH.addTimingFromPerformanceMark)(name, start, stopMark, cleanStart, true);
};
const $992d482032b2bb0b$export$e18462760bac553c = (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = fn();
    performance.mark(stopMark);
    $992d482032b2bb0b$var$safeMeasure(name, startMark, stopMark);
    (0, $acbV3.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $5pGvH.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $992d482032b2bb0b$export$53038a2e9d597818 = async (name, fn)=>{
    if (false) return fn();
    const startMark = `${name}__start_mark$`;
    const stopMark = `${name}__stop_mark$`;
    performance.mark(startMark);
    const result = await fn();
    performance.mark(stopMark);
    (0, $acbV3.browserMetrics).experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark);
    (0, $5pGvH.addTimingFromPerformanceMark)(name, startMark, stopMark, true, true);
    return result;
};
const $992d482032b2bb0b$export$de1b4cf109d9ab65 = ()=>{
    if (false) return;
    $992d482032b2bb0b$export$ab75d59423c060f4('product.bundle-ready', 'jira-spa.js:eval-stop');
};

});

parcelRegister("gd0Sp", function(module, exports) {

$parcel$export(module.exports, "TenantContextContainer", () => $b24af0bf593bb550$export$8b5d54c1fa2f746f);
$parcel$export(module.exports, "TenantContextSubscriber", () => $b24af0bf593bb550$export$9d1e1d1d0f8eeb35);
$parcel$export(module.exports, "useTenantContext", () => $b24af0bf593bb550$export$28e7c557f4d454d9);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $dYfll = parcelRequire("dYfll");

var $lI2HE = parcelRequire("lI2HE");

var $k4yit = parcelRequire("k4yit");
const $b24af0bf593bb550$export$8b5d54c1fa2f746f = (0, $heB5U.createContainer)((0, $k4yit.default), {
    onInit: ()=>({ dispatch: dispatch })=>dispatch($lI2HE.bootstrap())
});
const $b24af0bf593bb550$export$9d1e1d1d0f8eeb35 = (0, $dYfll.createSubscriber)((0, $k4yit.default), {
    displayName: 'TenantContextSubscriber'
});
const $b24af0bf593bb550$export$b24a99788063c041 = (0, $ggKAj.createHook)((0, $k4yit.default));
const $b24af0bf593bb550$export$28e7c557f4d454d9 = ()=>{
    const [{ tenantContext: tenantContext }] = $b24af0bf593bb550$export$b24a99788063c041();
    return tenantContext;
};

});
parcelRegister("lI2HE", function(module, exports) {

$parcel$export(module.exports, "bootstrap", () => $cc772bba6bf195db$export$36aff1fbb4f5dfc6);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-legacy

var $e91YZ = parcelRequire("e91YZ");
const $cc772bba6bf195db$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState, getState: getState }, { getMeta: getMeta })=>{
        if (getState().tenantContext) return;
        const tenantContext = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)(getMeta);
        setState({
            tenantContext: tenantContext
        });
    };

});

parcelRegister("k4yit", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6b1174c6954228$export$2e2bcd8739ae039);

var $a61MH = parcelRequire("a61MH");

var $lI2HE = parcelRequire("lI2HE");
// @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'TenantContext'.
const $7a6b1174c6954228$var$initialState = {
    tenantContext: null
};
var $7a6b1174c6954228$export$2e2bcd8739ae039 = (0, $a61MH.createStore)({
    name: 'tenantContext',
    initialState: $7a6b1174c6954228$var$initialState,
    actions: $lI2HE
});

});


parcelRegister("dfiLi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d7be546ddbff67d$export$2e2bcd8739ae039);

var $3DOEL = parcelRequire("3DOEL");

var $d7XuA = parcelRequire("d7XuA");

var $k7tbJ = parcelRequire("k7tbJ");

var $l6Ms4 = parcelRequire("l6Ms4");

var $c40nn = parcelRequire("c40nn");
var /**
 * Initializes the analytics web client with configuration tailored to the user and product environment.
 * It dynamically adjusts settings based on user and organizational details to enhance product analytics.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$2d7be546ddbff67d$export$2e2bcd8739ae039 = ({ cloudId: cloudId, cloudName: cloudName, atlassianAccountId: atlassianAccountId, environment: environment, locale: locale, orgId: orgId, activationId: workspaceId })=>(0, $3DOEL.initAnalyticsWebClient)({
        tenantId: cloudId,
        ...atlassianAccountId ? {
            userId: atlassianAccountId
        } : undefined,
        ...orgId && {
            orgId: orgId
        },
        ...workspaceId && {
            workspaceId: workspaceId
        },
        product: 'jira',
        environment: environment === 'prod' ? 'prod' : (0, $l6Ms4.default)({
            cloudId: cloudId,
            cloudName: cloudName,
            environment: environment
        }),
        callback: (0, $c40nn.logEmau),
        subProduct: (0, $k7tbJ.default),
        solutions: (0, $d7XuA.default)(),
        locale: locale
    });

});
parcelRegister("d7XuA", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a015b4d9e08045$export$2e2bcd8739ae039);


var $k7tbJ = parcelRequire("k7tbJ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a015b4d9e08045$export$2e2bcd8739ae039 = ()=>(0, $k7tbJ.default)() === 'serviceDesk' ? [
        (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
    ] : undefined;

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';

parcelRegister("k7tbJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3c3c5b955d596d9$export$2e2bcd8739ae039);

var $6rW04 = parcelRequire("6rW04");

var $l57QR = parcelRequire("l57QR");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e3c3c5b955d596d9$export$2e2bcd8739ae039 = ()=>(0, $l57QR.default)((0, $6rW04.default)('ajs-application-key'));

});
parcelRegister("l57QR", function(module, exports) {

$parcel$export(module.exports, "default", () => $068e15f3e0fc2ee2$export$2e2bcd8739ae039);
/**
 * Transforms sub-product identifiers into a simplified or generic form, providing
 * a default when unspecified. This aids in standardizing the representation of
 * sub-product names across different contexts.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $068e15f3e0fc2ee2$export$2e2bcd8739ae039 = (subProduct)=>{
    if (!subProduct) return 'unknown';
    if (subProduct === 'family') return 'platform';
    if (subProduct === 'jira-servicedesk') return 'serviceDesk';
    if (subProduct.startsWith('jira-')) return subProduct.replace('jira-', '');
    return subProduct;
};

});



parcelRegister("l6Ms4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d749c4110ed3ad54$export$2e2bcd8739ae039);
// MR - stands for the atlassian monorepo prefix
const $d749c4110ed3ad54$var$isOverridingFragments = ()=>!!(window?.BUILD_KEY && !/^(?:MR)?JF-PROD-\d+$/.test(window.BUILD_KEY));
const $d749c4110ed3ad54$var$isOverridingSsr = ()=>!!(window?.SSR_BUILD_KEY && !/^(?:MR)?JF-PROD-\d+$/.test(window.SSR_BUILD_KEY));
const $d749c4110ed3ad54$var$isVoltExplore = ({ cloudId: cloudId, cloudName: cloudName })=>/^(TEST--)/.test(cloudId) && /^(atl-vertigo--jira-jira-branch)/.test(cloudName);
/**
 * Selects the 'staging' environment under specific conditions, defaulting to 'dev' otherwise.
 * This decision is based on the current environment setting and the absence of specific overrides.
 */ const $d749c4110ed3ad54$var$getStagingEnvironment = ({ environment: environment, cloudId: cloudId, cloudName: cloudName })=>{
    if (environment === 'staging' && !$d749c4110ed3ad54$var$isOverridingFragments() && !$d749c4110ed3ad54$var$isOverridingSsr() && !$d749c4110ed3ad54$var$isVoltExplore({
        cloudId: cloudId,
        cloudName: cloudName
    })) return environment;
    return 'dev';
};
var $d749c4110ed3ad54$export$2e2bcd8739ae039 = $d749c4110ed3ad54$var$getStagingEnvironment;

});

parcelRegister("c40nn", function(module, exports) {

$parcel$export(module.exports, "logEmau", () => $95a5427241eb11af$export$f6d9e07ca353aa2e);

var $fVqUX = parcelRequire("fVqUX");

var $e91YZ = parcelRequire("e91YZ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95a5427241eb11af$var$logEmauForJira = (subproduct, url, urlParams)=>{
    const body = JSON.stringify({
        eventData: {
            url: url,
            subproduct: subproduct,
            urlParams: urlParams
        }
    });
    const fetchOptions = {
        ...(0, $fVqUX.default),
        method: 'POST',
        body: body
    };
    const { baseUrl: baseUrl } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const endpointUrl = `${baseUrl}/rest/internal/2/log/unsafe/emau`;
    return fetch(endpointUrl, fetchOptions);
};
const $95a5427241eb11af$export$f6d9e07ca353aa2e = ({ product: product, subproduct: subproduct })=>{
    if (product === 'jira') $95a5427241eb11af$var$logEmauForJira(subproduct, window.location.pathname, window.location.search);
};

});


parcelRegister("3gru2", function(module, exports) {

$parcel$export(module.exports, "JiraStructuredAnalyticsListener", () => $d76621cbcf5a10b5$export$ba6a124597fff04a);

var $eUqFw = parcelRequire("eUqFw");

var $6PJBT = parcelRequire("6PJBT");

var $jYVKV = parcelRequire("jYVKV");

var $8jEfj = parcelRequire("8jEfj");

var $gUUjF = parcelRequire("gUUjF");

var $iKlrz = parcelRequire("iKlrz");

var $3FyZ4 = parcelRequire("3FyZ4");

var $lmnG4 = parcelRequire("lmnG4");
const $d76621cbcf5a10b5$var$EXCLUDED_CHANNELS = [
    (0, $6PJBT.FabricChannel).atlaskit
];
const $d76621cbcf5a10b5$var$addSearchPayload = (event, isProductAnalyticsV3 = false)=>{
    try {
        const searchPayload = (0, $lmnG4.addSearchSessionAttributes)();
        if (Object.keys(searchPayload).length > 0) {
            if (isProductAnalyticsV3) // eslint-disable-next-line no-param-reassign
            event.payload.attributes = {
                ...event.payload.attributes,
                ...searchPayload
            };
            else // eslint-disable-next-line no-param-reassign
            event.payload = {
                ...event.payload,
                ...searchPayload
            };
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('observability.analytics-providers.addSearchPayload', 'Failed to dynamically add search payload', e);
    }
    return event;
};
const $d76621cbcf5a10b5$var$getAnalyticsWebClientInstance = ()=>(0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
const $d76621cbcf5a10b5$var$sendAnalyticsEvent = (event)=>{
    // Preemptively create an error so we can find who sends invalid events in Sentry
    const callError = new Error(`This ${event.type} event is not valid`);
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        try {
            client.sendEvent(event);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            err.cause = callError;
            throw err;
        }
    });
};
const $d76621cbcf5a10b5$var$onStructuredAnalyticsEvent = (event)=>{
    const enrichedEvent = $d76621cbcf5a10b5$var$addSearchPayload(event);
    $d76621cbcf5a10b5$var$sendAnalyticsEvent((0, $8jEfj.default)(enrichedEvent));
};
const $d76621cbcf5a10b5$var$onProductAnalyticsV3 = (event)=>{
    const enrichedEvent = $d76621cbcf5a10b5$var$addSearchPayload(event, true);
    $d76621cbcf5a10b5$var$sendAnalyticsEvent((0, $iKlrz.getEvent)(enrichedEvent));
};
const $d76621cbcf5a10b5$var$JiraAnalyticsListener = ({ onEvent: onEvent, onEventV3: onEventV3, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
        onEvent: onEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
        onEvent: onEventV3,
        channel: "productAnalytics"
    }, children));
const $d76621cbcf5a10b5$export$ba6a124597fff04a = ({ children: children })=>{
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6PJBT.default), {
        // @ts-expect-error - Type 'GasPurePayload' is not assignable to type 'UITrackAndOperationalEventPayload'.
        client: $d76621cbcf5a10b5$var$getAnalyticsWebClientInstance(),
        excludedChannels: $d76621cbcf5a10b5$var$EXCLUDED_CHANNELS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d76621cbcf5a10b5$var$JiraAnalyticsListener, {
        onEvent: $d76621cbcf5a10b5$var$onStructuredAnalyticsEvent,
        onEventV3: $d76621cbcf5a10b5$var$onProductAnalyticsV3
    }, children));
};

});
parcelRegister("8jEfj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5e2e8f94c0063dc$export$2e2bcd8739ae039);

var $kkgbD = parcelRequire("kkgbD");

var $iTvqy = parcelRequire("iTvqy");

var $i7Fym = parcelRequire("i7Fym");

var $etqm0 = parcelRequire("etqm0");

var $dsPb0 = parcelRequire("dsPb0");
const $f5e2e8f94c0063dc$var$formatActionSubjectId = (name, actionSubject)=>actionSubject ? `${name}${actionSubject[0].toUpperCase()}${actionSubject.substring(1)}` : name;
const $f5e2e8f94c0063dc$var$getActionSubjectForEventType = (event, analyticsType)=>{
    if (analyticsType === (0, $etqm0.TRACK_EVENT_TYPE)) return (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $dsPb0.getActionSubjects)(event));
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $dsPb0.getComponents)(event));
};
const $f5e2e8f94c0063dc$var$getActionSubjectIdForEventType = (event, analyticsType, actionSubject)=>{
    const name = (0, $dsPb0.getName)(event);
    // for UI and operational events, the actionSubjectId is generated
    // but for operational events name is optional, since it doesnt always make sense.
    // Consider a high level component BespokeComponent. If this fires an internal event
    // The unique instance of the component is likely to be BespokeComponent (ie there is 1)
    // so if name wasn't optional we would end up with actionSubjectId=bespokeComponentBespokeComponent
    if (analyticsType === (0, $etqm0.OPERATIONAL_EVENT_TYPE)) return name ? $f5e2e8f94c0063dc$var$formatActionSubjectId(name, actionSubject) : actionSubject;
    if (analyticsType === (0, $etqm0.UI_EVENT_TYPE)) return $f5e2e8f94c0063dc$var$formatActionSubjectId(name, actionSubject);
    return (0, $dsPb0.getActionSubjectId)(event);
};
var /**
 * This util exists to bridge the two different formats between atlaskit and the data services events. Two formats are required because
 * atlaskit needs to be able to collect aribtrary events from the tree while the data service event doesn't (and shouldn't) care about the react tree.
 *
 * Atlaskit event format:
 *
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Data Services event format:
 *  event {
 *      type: <"TRACK"|"SCREEN"|"UI"|"OPERATIONAL">
 *      payload {
 *          ...mandatoryFieldsBasedOnEventType
 *          ...optionalFieldsBasedOnEventType
 *          attributes: {
 *              ...arbirtaryAttributes
 *          }
 *      }
 *  }
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f5e2e8f94c0063dc$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $dsPb0.getSources)(event);
    const analyticsType = (0, $dsPb0.getAnalyticsType)(event);
    const actionSubject = $f5e2e8f94c0063dc$var$getActionSubjectForEventType(event, analyticsType);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(sources);
    const action = (0, $dsPb0.getAction)(event);
    const attributes = {
        ...(0, $dsPb0.getAttributes)(event),
        namespaces: sources.join('.')
    };
    const containers = (0, $dsPb0.getContainers)(event);
    if (action === (0, $etqm0.PAGE_EVENT_ACTION)) return {
        type: (0, $etqm0.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes,
            containers: containers
        }
    };
    switch(analyticsType){
        case 0, $etqm0.UI_EVENT_TYPE:
        case 0, $etqm0.TRACK_EVENT_TYPE:
        case 0, $etqm0.OPERATIONAL_EVENT_TYPE:
            {
                const actionSubjectId = $f5e2e8f94c0063dc$var$getActionSubjectIdForEventType(event, analyticsType, actionSubject);
                const containerId = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $dsPb0.getContainerIds)(event));
                const containerType = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $dsPb0.getContainerTypes)(event));
                const objectId = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $dsPb0.getObjectIds)(event));
                const objectType = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))((0, $dsPb0.getObjectTypes)(event));
                const tags = (0, $dsPb0.getTags)(event);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerId: containerId,
                        containers: containers,
                        containerType: containerType,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes,
                    containers: containers
                },
                type: undefined
            };
    }
};

});
parcelRegister("etqm0", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", () => $078b16f77743528b$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $078b16f77743528b$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $078b16f77743528b$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $078b16f77743528b$export$12346a674644c156);
$parcel$export(module.exports, "PAGE_EVENT_ACTION", () => $078b16f77743528b$export$a953886d20994732);
$parcel$export(module.exports, "ScreenTypes", () => $078b16f77743528b$export$9dd85b191ff3384f);
/**
 * ANALYTICS WEB CLIENT EVENTS
 */ // those events are going to the analytics web client
const $078b16f77743528b$export$a1562d08625f5d7e = 'UI';
const $078b16f77743528b$export$947dac6c72b26f81 = 'TRACK';
const $078b16f77743528b$export$f1d537d508d2945a = 'SCREEN';
const $078b16f77743528b$export$12346a674644c156 = 'OPERATIONAL';
const $078b16f77743528b$export$a953886d20994732 = 'page-view';
const $078b16f77743528b$var$SCREEN = 'Screen';
const $078b16f77743528b$var$DRAWER = 'Drawer';
const $078b16f77743528b$var$MODAL = 'Modal';
const $078b16f77743528b$var$INLINE_DIALOG = 'InlineDialog';
const $078b16f77743528b$var$DROPDOWN = 'Dropdown';
const $078b16f77743528b$export$9dd85b191ff3384f = {
    SCREEN: $078b16f77743528b$var$SCREEN,
    MODAL: $078b16f77743528b$var$MODAL,
    DRAWER: $078b16f77743528b$var$DRAWER,
    INLINE_DIALOG: $078b16f77743528b$var$INLINE_DIALOG,
    DROPDOWN: $078b16f77743528b$var$DROPDOWN
};

});

parcelRegister("dsPb0", function(module, exports) {

$parcel$export(module.exports, "getComponents", () => $0363a3bbf322cec4$export$4e811121b221213b);
$parcel$export(module.exports, "getActionSubjects", () => $0363a3bbf322cec4$export$d9a2a7d6b7a9497b);
$parcel$export(module.exports, "getSources", () => $0363a3bbf322cec4$export$5f9bc633b116660f);
$parcel$export(module.exports, "getAttributes", () => $0363a3bbf322cec4$export$fe94072fee8a6976);
$parcel$export(module.exports, "getTags", () => $0363a3bbf322cec4$export$af63d7414243dad3);
$parcel$export(module.exports, "getContainerTypes", () => $0363a3bbf322cec4$export$94b487dda8940141);
$parcel$export(module.exports, "getContainerIds", () => $0363a3bbf322cec4$export$9a462447889d734e);
$parcel$export(module.exports, "getObjectTypes", () => $0363a3bbf322cec4$export$9ed2cbb83cd51da0);
$parcel$export(module.exports, "getObjectIds", () => $0363a3bbf322cec4$export$2e78a279ad2bf08);
$parcel$export(module.exports, "getActionSubjectId", () => $0363a3bbf322cec4$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getAnalyticsType", () => $0363a3bbf322cec4$export$a3569ac53b82a914);
$parcel$export(module.exports, "getName", () => $0363a3bbf322cec4$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getAction", () => $0363a3bbf322cec4$export$6ca3170acb89054);
$parcel$export(module.exports, "getContainers", () => $0363a3bbf322cec4$export$ae861c5c02c4c14c);

var $kkgbD = parcelRequire("kkgbD");

var $2vzCR = parcelRequire("2vzCR");

var $i7Fym = parcelRequire("i7Fym");

var $MdoH4 = parcelRequire("MdoH4");
const $0363a3bbf322cec4$var$extractFromEventContext = (propertyNames, event)=>event.context // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            acc.push(contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $0363a3bbf322cec4$var$extractFromEventPayload = (propertyName, event)=>event.payload[propertyName];
const $0363a3bbf322cec4$var$extractFromPayloadOrContext = (propertyName, event)=>{
    const payloadProp = $0363a3bbf322cec4$var$extractFromEventPayload(propertyName, event);
    const contextProps = $0363a3bbf322cec4$var$extractFromEventContext([
        propertyName
    ], event);
    return payloadProp ? contextProps.concat(payloadProp) : contextProps;
};
const $0363a3bbf322cec4$var$extractPayloadAttributes = (event)=>{
    const { tags: tags, actionSubjectId: actionSubjectId, containerType: containerType, containerId: containerId, objectType: objectType, objectId: objectId, analyticsType: analyticsType, name: name, action: action, ...attributes } = event.payload;
    return attributes;
};
const $0363a3bbf322cec4$export$4e811121b221213b = (event)=>$0363a3bbf322cec4$var$extractFromEventContext([
        'component',
        'componentName'
    ], event);
const $0363a3bbf322cec4$export$d9a2a7d6b7a9497b = (event)=>$0363a3bbf322cec4$var$extractFromEventContext([
        'actionSubject'
    ], event);
const $0363a3bbf322cec4$export$5f9bc633b116660f = (event)=>$0363a3bbf322cec4$var$extractFromEventContext([
        'source'
    ], event);
const $0363a3bbf322cec4$export$fe94072fee8a6976 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $0363a3bbf322cec4$var$extractFromEventContext([
        'attributes'
    ], event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(result, extraAttributes), {}), $0363a3bbf322cec4$var$extractPayloadAttributes(event));
const $0363a3bbf322cec4$export$af63d7414243dad3 = (event)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))($0363a3bbf322cec4$var$extractFromEventContext([
        'tags'
    ], event) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, extraTags)=>result.concat(extraTags), []).concat($0363a3bbf322cec4$var$extractFromEventPayload('tags', event)).filter(Boolean));
    return tags.length > 0 ? tags : undefined;
};
const $0363a3bbf322cec4$export$94b487dda8940141 = (event)=>$0363a3bbf322cec4$var$extractFromPayloadOrContext('containerType', event);
const $0363a3bbf322cec4$export$9a462447889d734e = (event)=>$0363a3bbf322cec4$var$extractFromPayloadOrContext('containerId', event);
const $0363a3bbf322cec4$export$9ed2cbb83cd51da0 = (event)=>$0363a3bbf322cec4$var$extractFromPayloadOrContext('objectType', event);
const $0363a3bbf322cec4$export$2e78a279ad2bf08 = (event)=>$0363a3bbf322cec4$var$extractFromPayloadOrContext('objectId', event);
const $0363a3bbf322cec4$export$b6f8db3ad0711b02 = (event)=>$0363a3bbf322cec4$var$extractFromEventPayload('actionSubjectId', event);
const $0363a3bbf322cec4$export$a3569ac53b82a914 = (event)=>$0363a3bbf322cec4$var$extractFromEventPayload('analyticsType', event);
const $0363a3bbf322cec4$export$7d9f7e9c1c02b41e = (event)=>$0363a3bbf322cec4$var$extractFromEventPayload('name', event);
const $0363a3bbf322cec4$export$6ca3170acb89054 = (event)=>$0363a3bbf322cec4$var$extractFromEventPayload('action', event);
const $0363a3bbf322cec4$export$ae861c5c02c4c14c = (event)=>{
    const contextContainers = $0363a3bbf322cec4$var$extractFromEventContext([
        'containers'
    ], event);
    const payloadContainers = event.payload.containers;
    const allContainers = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    contextContainers.reduce((result, extraContainers)=>(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(result, extraContainers), {}), payloadContainers);
    const finalContainers = (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))(allContainers, (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD))));
    return Object.keys(finalContainers).length > 0 ? finalContainers : undefined;
};

});


parcelRegister("lmnG4", function(module, exports) {

$parcel$export(module.exports, "addSearchSessionAttributes", () => $f5f93c00af13f1f6$export$ee9fabaf3a23e7bf);

var $3QMTK = parcelRequire("3QMTK");

var $3LiTJ = parcelRequire("3LiTJ");

var $6rW04 = parcelRequire("6rW04");
const $f5f93c00af13f1f6$export$ee9fabaf3a23e7bf = (payload)=>{
    const safePayload = payload || {};
    const sessionAttributes = {
        searchSessionId: 'searchSessionId' in safePayload && safePayload.searchSessionId ? safePayload.searchSessionId : (0, $6rW04.default)('ajs-search-session-id'),
        searchObjectId: 'searchObjectId' in safePayload && safePayload.searchObjectId ? safePayload.searchObjectId : (0, $6rW04.default)('ajs-search-object-id'),
        searchContainerId: 'searchContainerId' in safePayload && safePayload.searchContainerId ? safePayload.searchContainerId : (0, $6rW04.default)('ajs-search-container-id'),
        searchContentType: 'searchContentType' in safePayload && safePayload.searchContentType ? safePayload.searchContentType : (0, $6rW04.default)('ajs-search-content-type')
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        ...payload,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($3LiTJ)))(sessionAttributes, (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))))
    };
};

});



parcelRegister("fb5Sn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2b911144530af190$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1C9jQ = parcelRequire("1C9jQ");

var $aQFDs = parcelRequire("aQFDs");

var $67SDP = parcelRequire("67SDP");

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $3FyZ4 = parcelRequire("3FyZ4");

var $38OPi = parcelRequire("38OPi");
/**
 * Conditionally renders its children or enriches them with specific configurations for engagement and analytics. This component acts differently based on the execution environment (server vs client) and the availability of user metadata, aiming to seamlessly integrate analytics functionality where applicable.
 */ const $2b911144530af190$var$EngagementProvider = (props)=>{
    if (false) return props.children;
    const environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment'));
    const getEnvironmentType = (env)=>{
        if (env === 'prod') return (0, $1C9jQ.envType).PROD;
        if (env === 'staging') return (0, $1C9jQ.envType).STAGING;
        return (0, $1C9jQ.envType).DEV;
    };
    const aaid = (0, $6rW04.default)('ajs-atlassian-account-id');
    if (aaid === null) return props.children;
    const config = {
        aaid: aaid,
        cloudId: (0, $6rW04.default)('ajs-cloud-id') || '',
        locale: (0, $6rW04.default)('ajs-user-locale') || '',
        product: 'jira',
        stargateUrl: '/gateway/api',
        orgId: props.orgId
    };
    const coordinationOptions = {
        envType: getEnvironmentType(environment),
        enableChoreographer: (0, $1ybV0.ff)('post-office_enable_jira_choreographer'),
        additionalData: {
            sourceProductId: (0, $67SDP.ProductIds).JIRA
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aQFDs.default), {
        ...props,
        config: config,
        analyticsClientInstance: Promise.resolve((0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>client.getInstance())),
        coordinationOptions: coordinationOptions
    });
};
var $2b911144530af190$export$2e2bcd8739ae039 = $2b911144530af190$var$EngagementProvider;

});

parcelRegister("hu0G4", function(module, exports) {

$parcel$export(module.exports, "localePropType", () => $536adac0847dddeb$export$ade363a7f01ce39d);
$parcel$export(module.exports, "defaultLocale", () => (parcelRequire("6GvCI")).defaultLocale);
$parcel$export(module.exports, "supportedLanguagesMap", () => (parcelRequire("6GvCI")).supportedLanguagesMap);
$parcel$export(module.exports, "getLocale", () => (parcelRequire("8K9kM")).getLocale);
$parcel$export(module.exports, "formatTimezonedWithLocale", () => (parcelRequire("8K9kM")).formatTimezonedWithLocale);
$parcel$export(module.exports, "floatDifferenceOfDates", () => (parcelRequire("8K9kM")).floatDifferenceOfDates);
$parcel$export(module.exports, "formatWithLocale", () => (parcelRequire("8K9kM")).formatWithLocale);
$parcel$export(module.exports, "formatDistanceWithLocale", () => (parcelRequire("8K9kM")).formatDistanceWithLocale);
$parcel$export(module.exports, "formatRelativeWithLocale", () => (parcelRequire("8K9kM")).formatRelativeWithLocale);
$parcel$export(module.exports, "formatDistanceStrictWithLocale", () => (parcelRequire("8K9kM")).formatDistanceStrictWithLocale);
$parcel$export(module.exports, "weekStartDayWithLocale", () => (parcelRequire("8K9kM")).weekStartDayWithLocale);
$parcel$export(module.exports, "formatZonedDateTimeWithZone", () => (parcelRequire("8K9kM")).formatZonedDateTimeWithZone);
$parcel$export(module.exports, "parseZoneDateTime", () => (parcelRequire("8K9kM")).parseZoneDateTime);
$parcel$export(module.exports, "setTimezoneOffset", () => (parcelRequire("8K9kM")).setTimezoneOffset);
$parcel$export(module.exports, "setNumberOffsetToISODate", () => (parcelRequire("8K9kM")).setNumberOffsetToISODate);
$parcel$export(module.exports, "formatDateStringToISO", () => (parcelRequire("8K9kM")).formatDateStringToISO);
$parcel$export(module.exports, "isValidTimeZone", () => (parcelRequire("8K9kM")).isValidTimeZone);
// eslint-disable-next-line jira/restricted/prop-types

var $1Qivz = parcelRequire("1Qivz");

var $4NKy8 = parcelRequire("4NKy8");

var $6GvCI = parcelRequire("6GvCI");

var $8K9kM = parcelRequire("8K9kM");
const $536adac0847dddeb$export$ade363a7f01ce39d = (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf(Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($4NKy8)))));

});
parcelRegister("4NKy8", function(module, exports) {
module.exports = JSON.parse("{\"cs_CZ\":\"cs-CZ\",\"cs\":\"cs-CZ\",\"da_DK\":\"da-DK\",\"da\":\"da-DK\",\"de_DE\":\"de-DE\",\"de\":\"de-DE\",\"en_GB\":\"en-GB\",\"en-GB\":\"en-GB\",\"en_UK\":\"en-US\",\"en-UK\":\"en-US\",\"enUS\":\"enUS\",\"en_US\":\"en-US\",\"en-US\":\"en-US\",\"es-ES\":\"es-ES\",\"es\":\"es-ES\",\"et_EE\":\"et-EE\",\"et\":\"et-EE\",\"fi_FI\":\"fi-FI\",\"fi\":\"fi-FI\",\"fr_FR\":\"fr-FR\",\"fr\":\"fr-FR\",\"hu_HU\":\"hu-HU\",\"hu\":\"hu-HU\",\"is_IS\":\"is-IS\",\"is\":\"is-IS\",\"it_IT\":\"it-IT\",\"it\":\"it-IT\",\"ja_JP\":\"ja-JP\",\"ja\":\"ja-JP\",\"ko_KR\":\"ko-KR\",\"ko\":\"ko-KR\",\"nb_NO\":\"nb-NO\",\"nb\":\"nb-NO\",\"nl_NL\":\"nl-NL\",\"nl\":\"nl-NL\",\"pl_PL\":\"pl-PL\",\"pl\":\"pl-PL\",\"pt_BR\":\"pt-BR\",\"pt-BR\":\"pt-BR\",\"pt_PT\":\"pt-PT\",\"pt\":\"pt-PT\",\"ro_RO\":\"ro-RO\",\"ro\":\"ro-RO\",\"ru_RU\":\"ru-RU\",\"ru\":\"ru-RU\",\"sk_SK\":\"sk-SK\",\"sk\":\"sk-SK\",\"sv_SE\":\"sv-SE\",\"sv\":\"sv-SE\",\"tr\":\"tr-TR\",\"tr_TR\":\"tr-TR\",\"tr-TR\":\"tr-TR\",\"zh_CN\":\"zh-CN\",\"zh-CN\":\"zh-CN\",\"zh_TW\":\"zh-TW\",\"zh-TW\":\"zh-TW\"}");

});

parcelRegister("6GvCI", function(module, exports) {

$parcel$export(module.exports, "defaultLocale", () => $2c0dcd440edac503$export$d7f512c98c859244);
$parcel$export(module.exports, "supportedLanguagesMap", () => $2c0dcd440edac503$export$ff4f0d1b20f0caad);
const $2c0dcd440edac503$export$d7f512c98c859244 = 'enUS';
const $2c0dcd440edac503$var$arabicLocale = 'arDZ';
const $2c0dcd440edac503$export$ff4f0d1b20f0caad = {
    ar: $2c0dcd440edac503$var$arabicLocale,
    ar_DZ: $2c0dcd440edac503$var$arabicLocale,
    ar_MA: $2c0dcd440edac503$var$arabicLocale,
    ar_SA: $2c0dcd440edac503$var$arabicLocale,
    cs_CZ: 'cs',
    cs: 'cs',
    da_DK: 'da',
    da: 'da',
    de_DE: 'de',
    de: 'de',
    en_GB: 'enGB',
    'en-GB': 'enGB',
    en_UK: $2c0dcd440edac503$export$d7f512c98c859244,
    'en-UK': $2c0dcd440edac503$export$d7f512c98c859244,
    en_US: $2c0dcd440edac503$export$d7f512c98c859244,
    'en-US': $2c0dcd440edac503$export$d7f512c98c859244,
    en_AU: 'enAU',
    es_ES: 'es',
    es: 'es',
    et_EE: 'et',
    et: 'et',
    fi_FI: 'fi',
    fi: 'fi',
    fr_FR: 'fr',
    fr: 'fr',
    hu_HU: 'hu',
    hu: 'hu',
    is_IS: 'is',
    is: 'is',
    it_IT: 'it',
    it: 'it',
    ja_JP: 'ja',
    ja: 'ja',
    ko_KR: 'ko',
    ko: 'ko',
    nb_NO: 'nb',
    nb: 'nb',
    nl_NL: 'nl',
    nl: 'nl',
    pl_PL: 'pl',
    pl: 'pl',
    pt_BR: 'ptBR',
    'pt-BR': 'ptBR',
    pt_PT: 'pt',
    pt: 'pt',
    ro_RO: 'ro',
    ro: 'ro',
    ru_RU: 'ru',
    ru: 'ru',
    sk_SK: 'sk',
    sk: 'sk',
    sv_SE: 'sv',
    sv: 'sv',
    tr: 'tr',
    tr_TR: 'tr',
    zh_CN: 'zhCN',
    'zh-CN': 'zhCN',
    zh_TW: 'zhTW',
    'zh-TW': 'zhTW'
};

});

parcelRegister("8K9kM", function(module, exports) {

$parcel$export(module.exports, "getLocale", () => $c5984910322e3d9f$export$180605366c04f0cd);
$parcel$export(module.exports, "isValidTimeZone", () => $c5984910322e3d9f$export$c793e14020d7c7b);
$parcel$export(module.exports, "formatWithLocale", () => $c5984910322e3d9f$export$fb3485f471c77284);
$parcel$export(module.exports, "formatTimezonedWithLocale", () => $c5984910322e3d9f$export$4383dd42a084ef32);
$parcel$export(module.exports, "formatDistanceWithLocale", () => $c5984910322e3d9f$export$c2180807b950d3da);
$parcel$export(module.exports, "formatRelativeWithLocale", () => $c5984910322e3d9f$export$12b50b1737ea07fc);
$parcel$export(module.exports, "formatDistanceStrictWithLocale", () => $c5984910322e3d9f$export$7a7656c130da0e93);
$parcel$export(module.exports, "weekStartDayWithLocale", () => $c5984910322e3d9f$export$d2c1381944cd40d9);
$parcel$export(module.exports, "parseZoneDateTime", () => $c5984910322e3d9f$export$736ce978ed45f974);
$parcel$export(module.exports, "setTimezoneOffset", () => $c5984910322e3d9f$export$11ef0295ba6f3d21);
$parcel$export(module.exports, "setNumberOffsetToISODate", () => $c5984910322e3d9f$export$fe2193e77e11d739);
$parcel$export(module.exports, "formatZonedDateTimeWithZone", () => $c5984910322e3d9f$export$dd52464bfc436f72);
$parcel$export(module.exports, "formatDateStringToISO", () => $c5984910322e3d9f$export$108dbdcbc1363368);
$parcel$export(module.exports, "floatDifferenceOfDates", () => $c5984910322e3d9f$export$8b999908ff0a4991);

var $8GsRb = parcelRequire("8GsRb");
var $5STnX = parcelRequire("5STnX");
var $3e6lq = parcelRequire("3e6lq");
var $EN9B6 = parcelRequire("EN9B6");
var $j4tJJ = parcelRequire("j4tJJ");
var $jtnES = parcelRequire("jtnES");
var $6W2Xn = parcelRequire("6W2Xn");
var $aiENI = parcelRequire("aiENI");
var $gzNmz = parcelRequire("gzNmz");
var $fU1L0 = parcelRequire("fU1L0");
var $7ueqz = parcelRequire("7ueqz");
var $5YjhU = parcelRequire("5YjhU");
var $3xcI8 = parcelRequire("3xcI8");
var $1HEy1 = parcelRequire("1HEy1");

var $4p54N = parcelRequire("4p54N");
var $bbmZl = parcelRequire("bbmZl");

var $jQ3SP = parcelRequire("jQ3SP");
var $9kKRr = parcelRequire("9kKRr");
var $idjIH = parcelRequire("idjIH");
var $eK2nW = parcelRequire("eK2nW");
var $l1vZX = parcelRequire("l1vZX");
var $6Ho7q = parcelRequire("6Ho7q");
var $8u3CS = parcelRequire("8u3CS");
var $kGGY0 = parcelRequire("kGGY0");
var $j8E2K = parcelRequire("j8E2K");
var $lzfDh = parcelRequire("lzfDh");
var $7ZhOe = parcelRequire("7ZhOe");
var $as8dL = parcelRequire("as8dL");
var $dIh1v = parcelRequire("dIh1v");
var $edlNU = parcelRequire("edlNU");
var $gR1HW = parcelRequire("gR1HW");
var $h2GF7 = parcelRequire("h2GF7");
var $bUyrf = parcelRequire("bUyrf");
var $6epED = parcelRequire("6epED");
var $2tyav = parcelRequire("2tyav");
var $7UPST = parcelRequire("7UPST");
var $7yLFy = parcelRequire("7yLFy");
var $lo1v9 = parcelRequire("lo1v9");
var $j6uJM = parcelRequire("j6uJM");
var $lMV1h = parcelRequire("lMV1h");
var $j0BRs = parcelRequire("j0BRs");
var $6xYHR = parcelRequire("6xYHR");
var $bMtcB = parcelRequire("bMtcB");
var $4hYec = parcelRequire("4hYec");

var $6GvCI = parcelRequire("6GvCI");
const $c5984910322e3d9f$var$locales = {
    arDZ: $jQ3SP.default,
    cs: $9kKRr.default,
    cs_CZ: (0, $9kKRr.default),
    da: $idjIH.default,
    da_DK: (0, $idjIH.default),
    de: $eK2nW.default,
    de_DE: (0, $eK2nW.default),
    enUS: $8u3CS.default,
    en_US: (0, $8u3CS.default),
    'en-US': (0, $8u3CS.default),
    enGB: $6Ho7q.default,
    en_UK: (0, $6Ho7q.default),
    'en-UK': (0, $6Ho7q.default),
    'en-GB': (0, $6Ho7q.default),
    en_GB: (0, $6Ho7q.default),
    enAU: $l1vZX.default,
    es: $kGGY0.default,
    es_ES: (0, $kGGY0.default),
    et: $j8E2K.default,
    et_EE: (0, $j8E2K.default),
    fi: $lzfDh.default,
    fi_FI: (0, $lzfDh.default),
    fr: $7ZhOe.default,
    fr_FR: (0, $7ZhOe.default),
    hu: $as8dL.default,
    hu_HU: (0, $as8dL.default),
    is: $dIh1v.default,
    is_IS: (0, $dIh1v.default),
    it: $edlNU.default,
    it_IT: (0, $edlNU.default),
    ja: $gR1HW.default,
    ja_JP: (0, $gR1HW.default),
    ko: $h2GF7.default,
    ko_KR: (0, $h2GF7.default),
    nb: $bUyrf.default,
    nb_NO: (0, $bUyrf.default),
    nl: $6epED.default,
    nl_NL: (0, $6epED.default),
    pl: $2tyav.default,
    pl_PL: (0, $2tyav.default),
    pt: $7UPST.default,
    'pt-PT': (0, $7UPST.default),
    pt_PT: (0, $7UPST.default),
    ptBR: $7yLFy.default,
    'pt-BR': (0, $7yLFy.default),
    pt_BR: (0, $7yLFy.default),
    ro: $lo1v9.default,
    ro_RO: (0, $lo1v9.default),
    ru: $j6uJM.default,
    ru_RU: (0, $j6uJM.default),
    sk: $lMV1h.default,
    sk_SK: (0, $lMV1h.default),
    sv: $j0BRs.default,
    sv_SE: (0, $j0BRs.default),
    tr: $6xYHR.default,
    'tr-TR': (0, $6xYHR.default),
    tr_TR: (0, $6xYHR.default),
    zhCN: $bMtcB.default,
    'zh-CN': (0, $bMtcB.default),
    zh_CN: (0, $bMtcB.default),
    zhTW: $4hYec.default,
    'zh-TW': (0, $4hYec.default),
    zh_TW: (0, $4hYec.default)
};
const $c5984910322e3d9f$var$nonUTCFullZoneRegExp = new RegExp(/:\d\d(\.\d+)?[-,+]\d\d:\d\d$/);
const $c5984910322e3d9f$var$negativeZoneRegExp = new RegExp(/:\d\d(\.\d+)?-/);
const $c5984910322e3d9f$var$milliseconds\u0421oefficients = {
    seconds: 1000,
    minutes: 60000,
    // 1000 * 60
    hours: 3600000,
    // 1000 * 60 * 60
    days: 86400000,
    // 1000 * 60 * 60 * 24
    weeks: 604800000
};
const $c5984910322e3d9f$export$180605366c04f0cd = (locale)=>{
    const dateFnsLocale = (0, $6GvCI.supportedLanguagesMap)[locale] || (0, $6GvCI.defaultLocale);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly arDZ: Locale; readonly cs: Locale; readonly cs_CZ: Locale; readonly da: Locale; readonly da_DK: Locale; readonly de: Locale; ... 56 more ...; readonly zh_TW: Locale; }'.
    return $c5984910322e3d9f$var$locales[dateFnsLocale];
};
const $c5984910322e3d9f$export$c793e14020d7c7b = (tz)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: tz
        });
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ex) {
        return false;
    }
};
const $c5984910322e3d9f$export$fb3485f471c77284 = (date, formatStyle, locale)=>(0, $EN9B6.default)(date, formatStyle, {
        locale: $c5984910322e3d9f$export$180605366c04f0cd(locale)
    });
const $c5984910322e3d9f$export$4383dd42a084ef32 = (date, formatStyle, locale, timeZone)=>$c5984910322e3d9f$export$c793e14020d7c7b(timeZone) ? (0, $4p54N.default)((0, $bbmZl.default)(date, timeZone), formatStyle, {
        locale: $c5984910322e3d9f$export$180605366c04f0cd(locale),
        timeZone: timeZone
    }) : (0, $4p54N.default)((0, $bbmZl.default)(date, 'utc'), formatStyle, {
        locale: $c5984910322e3d9f$export$180605366c04f0cd(locale),
        timeZone: 'utc'
    });
const $c5984910322e3d9f$export$c2180807b950d3da = (date, baseDate, locale, addSuffix = false)=>(0, $j4tJJ.default)(date, baseDate, {
        locale: $c5984910322e3d9f$export$180605366c04f0cd(locale),
        addSuffix: addSuffix
    });
const $c5984910322e3d9f$export$12b50b1737ea07fc = (date, baseDate, locale)=>(0, $6W2Xn.default)(date, baseDate, {
        locale: $c5984910322e3d9f$export$180605366c04f0cd(locale)
    });
const $c5984910322e3d9f$export$7a7656c130da0e93 = (date, baseDate, locale, addSuffix = false)=>(0, $jtnES.default)(date, baseDate, {
        locale: $c5984910322e3d9f$export$180605366c04f0cd(locale),
        addSuffix: addSuffix
    });
const $c5984910322e3d9f$export$d2c1381944cd40d9 = (date, locale)=>(0, $1HEy1.default)(date, {
        locale: $c5984910322e3d9f$export$180605366c04f0cd(locale)
    });
const $c5984910322e3d9f$export$736ce978ed45f974 = (parsingDate)=>{
    const date = typeof parsingDate === 'string' ? parsingDate : new Date().toISOString();
    const indxs = {
        positiveZoneStartIndex: date.indexOf('+'),
        negativeZoneStartIndex: $c5984910322e3d9f$var$negativeZoneRegExp.test(date) ? date.lastIndexOf('-') : -1,
        utcZoneStartIndex: date.indexOf('Z')
    };
    const zoneStartIndex = Object.values(indxs).find((el)=>typeof el === 'number' && el > -1);
    const parsedDate = typeof zoneStartIndex === 'number' ? date.substring(0, zoneStartIndex) : date;
    let zone = '';
    if (typeof zoneStartIndex === 'number') zone = $c5984910322e3d9f$var$nonUTCFullZoneRegExp.test(date) ? date.substring(zoneStartIndex, zoneStartIndex + 6) : `${date.substring(zoneStartIndex, zoneStartIndex + 3)}:00`;
    return {
        date: (0, $3xcI8.default)(parsedDate),
        zone: indxs.utcZoneStartIndex > -1 ? '+00:00' : zone
    };
};
const $c5984910322e3d9f$var$calcOffset = (zone)=>Number.parseInt(zone, 10) * 60 + Number.parseInt(`${zone.substring(0, 1)}${zone.substring(4)}`, 10);
const $c5984910322e3d9f$export$11ef0295ba6f3d21 = (date, offsetSource)=>{
    const dateOffset = date.getTimezoneOffset();
    const offset = $c5984910322e3d9f$var$calcOffset($c5984910322e3d9f$export$736ce978ed45f974(offsetSource).zone);
    return (0, $8GsRb.default)(date, offset + dateOffset); // plus because getTimezoneOffset returns difference in minutes (e.g. +3:00 => -180)
};
const $c5984910322e3d9f$export$fe2193e77e11d739 = (date, offsetHoursNumber)=>{
    const parsedDate = $c5984910322e3d9f$export$736ce978ed45f974(date);
    const originalOffset = $c5984910322e3d9f$var$calcOffset(parsedDate.zone);
    const calculatedDateTime = (0, $8GsRb.default)(parsedDate.date, offsetHoursNumber * 60 - originalOffset);
    return calculatedDateTime;
};
const $c5984910322e3d9f$export$dd52464bfc436f72 = (date, formatString, zone)=>{
    let res = '';
    const formatedString = (0, $EN9B6.default)(date, formatString);
    const indxs = {
        positiveZoneStartIndex: formatedString.indexOf('+'),
        negativeZoneStartIndex: $c5984910322e3d9f$var$negativeZoneRegExp.test(formatedString) ? formatedString.lastIndexOf('-') : -1,
        utcZoneStartIndex: formatedString.indexOf('Z')
    };
    const zoneStartIndex = Object.values(indxs).find((el)=>typeof el === 'number' && el > -1);
    if (typeof zoneStartIndex === 'number') res = `${formatedString.substring(0, zoneStartIndex)}${zone}`; // e.g. 2021-12-12T12:00:00+13:00
    return res;
};
const $c5984910322e3d9f$export$108dbdcbc1363368 = (date, formatString = 'yyyy-MM-dd')=>{
    const defaultReturnValue = '';
    if (date == null || date === '') return defaultReturnValue;
    const parsedDate = (0, $5YjhU.default)(date, formatString, new Date(0, 0, 0, 0, 0, 0));
    if (!(0, $7ueqz.default)(parsedDate)) return defaultReturnValue;
    return parsedDate.toISOString(); // formatISO can have issues with timezones: https://github.com/date-fns/date-fns/issues/2151 (
};
// this is copy of diff functions from moment.js
// @ts-expect-error - TS7023 - 'monthDiff' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
const $c5984910322e3d9f$var$monthDiff = (a, b)=>{
    if ((0, $aiENI.default)(a) < (0, $aiENI.default)(b)) // end-of-month calculations work correct when the start month has more
    // days than the end month.
    return -$c5984910322e3d9f$var$monthDiff(b, a);
    // difference in months
    const wholeMonthDiff = ((0, $fU1L0.default)(b) - (0, $fU1L0.default)(a)) * 12 + ((0, $gzNmz.default)(b) - (0, $gzNmz.default)(a));
    // b is in (anchor - 1 month, anchor + 1 month)
    const anchor = (0, $5STnX.default)(a, wholeMonthDiff);
    let anchor2;
    let adjust;
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    if (b - anchor < 0) {
        anchor2 = (0, $5STnX.default)(a, wholeMonthDiff - 1);
        // linear across the month
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = (0, $5STnX.default)(a, wholeMonthDiff + 1);
        // linear across the month
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        adjust = (b - anchor) / (anchor2 - anchor);
    }
    // check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
};
const $c5984910322e3d9f$export$8b999908ff0a4991 = (endDate, startDate, measurement)=>{
    const zoneDelta = startDate.getTimezoneOffset() * -60000 - endDate.getTimezoneOffset() * -60000; // copied from moment
    switch(measurement){
        case 'years':
            return $c5984910322e3d9f$var$monthDiff(endDate, startDate) / 12;
        case 'quarters':
            return $c5984910322e3d9f$var$monthDiff(endDate, startDate) / 3;
        case 'months':
            return $c5984910322e3d9f$var$monthDiff(endDate, startDate);
        case 'weeks':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate - zoneDelta) / $c5984910322e3d9f$var$milliseconds\u0421oefficients.weeks;
        // negate dst
        case 'days':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate - zoneDelta) / $c5984910322e3d9f$var$milliseconds\u0421oefficients.days;
        // negate dst
        case 'hours':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $c5984910322e3d9f$var$milliseconds\u0421oefficients.hours;
        case 'minutes':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $c5984910322e3d9f$var$milliseconds\u0421oefficients.minutes;
        case 'seconds':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $c5984910322e3d9f$var$milliseconds\u0421oefficients.seconds;
        default:
            return (0, $3e6lq.default)(endDate, startDate);
    }
};

});



parcelRegister("5BRby", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3001b0c6d483f1a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $lNNXV = parcelRequire("lNNXV");
/**
 * Acts as a foundational layer for applications, dynamically integrating either an error boundary or a Redux provider based on props. This component ensures that child components have access to application state via Redux and robust error handling through conditional error boundaries. It enhances application stability and state management practices by providing these critical infrastructural features.
 */ // eslint-disable-next-line jira/react/no-class-components
class $d3001b0c6d483f1a$var$AppBase extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            id: undefined,
            store: undefined,
            hasErrorBoundary: true
        };
    }
    renderChildrenWithStore() {
        if (!this.props.store) return this.props.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lNNXV.Provider), {
            store: this.props.store
        }, this.props.children);
    }
    render() {
        if (this.props.hasErrorBoundary) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: this.props.id ?? '@atlassian/jira-app-base::unknown-app',
            teamName: this.props.teamName,
            // JSErrorBoundary has page as the default, so we opt-out here for now
            fallback: this.props.fallback ?? 'flag',
            // TODO: packageName should be required. Every call-site
            // should be updated to pass it.
            packageName: this.props.packageName ?? '@atlassian/jira-app-base'
        }, this.renderChildrenWithStore());
        return this.renderChildrenWithStore();
    }
}
var $d3001b0c6d483f1a$export$2e2bcd8739ae039 = $d3001b0c6d483f1a$var$AppBase;

});
parcelRegister("0cdA8", function(module, exports) {

$parcel$export(module.exports, "JSErrorBoundary", () => $3d966c529009fe58$export$1e964c961b2b98bf);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("ciZ8Y");
var $5GxEP = parcelRequire("5GxEP");

var $fee69 = parcelRequire("fee69");

var $bEZRh = parcelRequire("bEZRh");

var $aR8n6 = parcelRequire("aR8n6");
const $3d966c529009fe58$var$ErrorPage = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.JSErrorPageAsync), {
        error: error
    });
const $3d966c529009fe58$var$Empty = ()=>null;
const $3d966c529009fe58$var$getFallback = (fallback, ErrorFlag)=>{
    switch(fallback){
        case 'page':
            return $3d966c529009fe58$var$ErrorPage;
        case 'flag':
            return ErrorFlag;
        case 'unmount':
            return $3d966c529009fe58$var$Empty;
        default:
            return fallback;
    }
};
const $3d966c529009fe58$export$1e964c961b2b98bf = ({ id: id, packageName: packageName, teamName: teamName, fallback: fallback = 'page', children: children, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk, onError: onError, ...rest })=>{
    const ErrorFlag = (0, $eUqFw.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorFlagRenderer), {
            id: id,
            error: error
        }), [
        id
    ]);
    const onErrorHandler = (0, $eUqFw.useCallback)((location, error, errorAttributes)=>{
        if (onError) onError(location, error, errorAttributes);
    }, [
        onError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        render: $3d966c529009fe58$var$getFallback(fallback, ErrorFlag),
        onError: onErrorHandler,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: attributes,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    }, children));
};
$3d966c529009fe58$export$1e964c961b2b98bf.defaultProps = {
    extraEventData: {}
};

});
parcelRegister("ciZ8Y", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => (parcelRequire("5GxEP")).default);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $aR8n6 = parcelRequire("aR8n6");

var $gGtKh = parcelRequire("gGtKh");

var $5GxEP = parcelRequire("5GxEP");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $59c9205fa5e73066$var$ErrorPageLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("fsWj7")).then((module)=>module.ErrorPage), {
    moduleId: "./src/packages/platform/ui/error-boundary/src/ui/error-page/index.tsx"
});
const $59c9205fa5e73066$export$c120a0e80fd44ca6 = (props)=>{
    const packageDetails = {
        id: 'asyncErrorPageComponent',
        packageName: 'jiraErrorBoundary'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), packageDetails, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        teamName: "magma",
        ...packageDetails
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "error-boundary",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($59c9205fa5e73066$var$ErrorPageLazy, props))));
};
const $59c9205fa5e73066$var$renderErrorPage = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($59c9205fa5e73066$export$c120a0e80fd44ca6, {
        error: error
    });
/**
 * An error boundary that will render an atlaskit empty state when a render
 *  exception is thrown.
 *
 * @deprecated Do not use directly, instead use `JSErrorBoundary` in
 * `@atlassian/jira-error-boundaries`, which will log appropriate errors to
 * Sentry/SFX/Splunk. See https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/jira/docs/playbook/uncaught-error-handling.md
 */ const $59c9205fa5e73066$export$26247a860ad008b8 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        ...props,
        render: $59c9205fa5e73066$var$renderErrorPage
    }, children);
$59c9205fa5e73066$export$26247a860ad008b8.defaultProps = {
    extraEventData: {},
    id: undefined
};

});
parcelRegister("aR8n6", function(module, exports) {

$parcel$export(module.exports, "default", () => $74a113ffb5962805$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");

var $guiFP = parcelRequire("guiFP");
class $74a113ffb5962805$var$CatchAndReportErrors extends (0, $eUqFw.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, teamName: teamName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $guiFP.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName,
                teamName: teamName
            },
            attributes: typeof attributes === 'function' ? attributes(error) : attributes,
            sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
        });
        throw error;
    }
    render() {
        return this.props.children;
    }
}
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$74a113ffb5962805$export$2e2bcd8739ae039 = (0, $2jDha.default)()($74a113ffb5962805$var$CatchAndReportErrors);

});

parcelRegister("gGtKh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b41bfbca8579a5c7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $1ybV0 = parcelRequire("1ybV0");

var $2UVt9 = parcelRequire("2UVt9");

var $5iuyH = parcelRequire("5iuyH");
function $b41bfbca8579a5c7$var$Hold({ name: name }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    const waitContext = (0, $eUqFw.useContext)((0, $7rh0R.WaitContext));
    // Runs synchronously, to allow us to identify async items
    (0, $2UVt9.default)(()=>{
        // if until context exists means there is a LazyWait parent component
        // we use that value
        const shouldHold = waitContext ? !!waitContext.currentValue() : true;
        if (interactionContext != null && shouldHold) return interactionContext.hold(name);
    }, [
        interactionContext,
        name,
        waitContext
    ]);
    return null;
}
function $b41bfbca8579a5c7$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback }) {
    // react-18: can use fallback directly
    const fb = fallback != null ? fallback : null;
    // react-18: can use children directly
    const kids = children != null ? children : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: (0, $1ybV0.ff)('ufo.placeholder') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fb, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b41bfbca8579a5c7$var$Hold, {
            name: name
        })) : fb,
        name: name
    }, kids);
}

});
parcelRegister("2UVt9", function(module, exports) {

$parcel$export(module.exports, "default", () => $89f3a297bfc9e881$export$2e2bcd8739ae039);
// code-reaper-ignore-file -- Uses `useLayoutEffect` in the browser and `useEffect` in the server.

var $eUqFw = parcelRequire("eUqFw");
var $89f3a297bfc9e881$export$2e2bcd8739ae039 = (0, $eUqFw.useLayoutEffect);

});


parcelRegister("5GxEP", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryInner", () => $472ba2165fad4e61$export$4b4ea7be124cdbd8);
$parcel$export(module.exports, "default", () => $472ba2165fad4e61$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwMhr = parcelRequire("kwMhr");

var $gUUjF = parcelRequire("gUUjF");

var $8xmdY = parcelRequire("8xmdY");
var $iH6c1 = parcelRequire("iH6c1");

var $5iuyH = parcelRequire("5iuyH");

var $gnIbC = parcelRequire("gnIbC");

var $fVaJL = parcelRequire("fVaJL");
const $472ba2165fad4e61$var$EGRESS_LIMIT = 5;
const $472ba2165fad4e61$var$getLocation = ({ id: id, packageName: packageName, prefixOverride: prefixOverride })=>{
    const prefix = prefixOverride != null ? prefixOverride : 'common';
    if (id != null) return packageName != null ? `${prefix}.error-boundary.${packageName}.${id}` : `${prefix}.error-boundary.${id}`;
    return `${prefix}.error-boundary`;
};
const $472ba2165fad4e61$var$ErrorBoundary = (props)=>{
    const interactionId = (0, $eUqFw.useContext)((0, $gnIbC.default));
    const interactionContext = (0, $eUqFw.useContext)((0, $5iuyH.default));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($472ba2165fad4e61$export$4b4ea7be124cdbd8, {
        ...props,
        ufoInteractionId: interactionId.current,
        ufoLabelStack: interactionContext?.labelStack
    });
};
class $472ba2165fad4e61$export$4b4ea7be124cdbd8 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            children: null,
            extraEventData: {},
            render: ()=>null,
            withExperienceTracker: false,
            onError: ()=>undefined,
            ufoInteractionId: null,
            ufoLabelStack: null
        };
    }
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.errorFrequencyMap = new Map();
    }
    // go/jfe-eslint
    // eslint-disable-next-line react/sort-comp
    static logErrorToSplunk(hash, location, event) {
        let occurrences;
        if (hash !== undefined) {
            // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
            occurrences = (this.errorFrequencyMap.get(hash) ?? 0) + 1;
            // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
            this.errorFrequencyMap.set(hash, occurrences);
        } else // If there's no hash, treat it as the first time
        occurrences = 1;
        // Only send the error log if we are below the egress limit
        if (occurrences <= $472ba2165fad4e61$var$EGRESS_LIMIT) (0, $gUUjF.default).safeErrorWithoutCustomerData(location, 'Unhandled error caught by error boundary', event);
    }
    static reportError(error, info, { id: id, packageName: packageName, teamName: teamName, prefixOverride: prefixOverride, onError: onError, extraEventData: extraEventData = {} }, interactionId, labelStack) {
        const hash = (0, $iH6c1.getErrorHash)(error);
        const event = {
            teamName: teamName ?? null,
            ...extraEventData,
            message: error.message ?? null,
            stack: error.stack ?? null,
            componentStack: info.componentStack,
            hash: hash ?? null
        };
        const location = $472ba2165fad4e61$var$getLocation({
            id: id,
            packageName: packageName,
            prefixOverride: prefixOverride
        });
        $472ba2165fad4e61$export$4b4ea7be124cdbd8.logErrorToSplunk(hash, location, event);
        (0, $8xmdY.captureException)(location, error, info);
        if (interactionId) (0, $fVaJL.addError)(interactionId, `JSErrorBoundary:${id}`, labelStack || null, error.name, error.message, error.stack);
        else (0, $fVaJL.addErrorToAll)(`JSErrorBoundary:${id}`, labelStack || null, error.name, error.message, error.stack);
        if (onError) onError(location, error, event);
    }
    static getDerivedStateFromProps(props, state) {
        if (!!props.resetCaughtError && state.caughtError?.error === props.resetCaughtError) return {
            ...state,
            caughtError: null
        };
        return state;
    }
    componentDidCatch(error, info) {
        const { id: id, packageName: packageName, teamName: teamName, prefixOverride: prefixOverride, onError: onError, extraEventData: extraEventData } = this.props;
        this.setState({
            caughtError: {
                error: error,
                info: info
            }
        });
        // passing this.props will cause "'onError' PropType is defined but prop is never used" eslint error
        $472ba2165fad4e61$export$4b4ea7be124cdbd8.reportError(error, info, {
            id: id,
            packageName: packageName,
            teamName: teamName,
            prefixOverride: prefixOverride,
            onError: onError,
            extraEventData: extraEventData
        }, this.props.ufoInteractionId, this.props.ufoLabelStack);
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children, render: renderFallback, withExperienceTracker: withExperienceTracker, extraEventData: extraEventData } = this.props;
        if (!caughtError) return children;
        const location = $472ba2165fad4e61$var$getLocation(this.props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderFallback({
            error: caughtError.error
        }), withExperienceTracker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: extraEventData
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            caughtError: null
        };
    }
}
var $472ba2165fad4e61$export$2e2bcd8739ae039 = $472ba2165fad4e61$var$ErrorBoundary;

});
parcelRegister("kwMhr", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccessTracker", () => $3f502b146aa35f1d$export$b721eda798584098);
$parcel$export(module.exports, "ExperienceFailureTracker", () => $3f502b146aa35f1d$export$7877e129ff70728d);
$parcel$export(module.exports, "ExperienceAbortTracker", () => $3f502b146aa35f1d$export$69d4d8a5c14b1454);
$parcel$export(module.exports, "ExperienceResultFromPropsTracker", () => $3f502b146aa35f1d$export$be2c49f6982d0964);

var $eUqFw = parcelRequire("eUqFw");

var $8yne0 = parcelRequire("8yne0");
class $3f502b146aa35f1d$export$2a8244c81400d030 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            hasSucceeded: false,
            hasFailed: false,
            hasAborted: false,
            children: null
        };
    }
    componentDidMount() {
        this.postRenderChecks();
    }
    componentDidUpdate() {
        this.postRenderChecks();
    }
    postRenderChecks() {
        const { onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort, hasSucceeded: hasSucceeded, hasFailed: hasFailed, hasAborted: hasAborted } = this.props;
        if (hasFailed) onExperienceFailure();
        else if (hasAborted) onExperienceAbort();
        else if (hasSucceeded) onExperienceSuccess();
    }
    render() {
        return this.props.children;
    }
}
const $3f502b146aa35f1d$export$b721eda798584098 = ({ children: children, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), props, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f502b146aa35f1d$export$2a8244c81400d030, {
            hasSucceeded: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$3f502b146aa35f1d$export$b721eda798584098.defaultProps = (0, $8yne0.defaultProps);
const $3f502b146aa35f1d$export$7877e129ff70728d = ({ children: children, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), props, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f502b146aa35f1d$export$2a8244c81400d030, {
            hasFailed: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$3f502b146aa35f1d$export$7877e129ff70728d.defaultProps = (0, $8yne0.defaultProps);
const $3f502b146aa35f1d$export$69d4d8a5c14b1454 = ({ children: children, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), props, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f502b146aa35f1d$export$2a8244c81400d030, {
            hasAborted: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$3f502b146aa35f1d$export$69d4d8a5c14b1454.defaultProps = (0, $8yne0.defaultProps);
const $3f502b146aa35f1d$export$be2c49f6982d0964 = ({ hasSucceeded: hasSucceeded, hasFailed: hasFailed, hasAborted: hasAborted, children: children, ...trackerProps })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), trackerProps, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f502b146aa35f1d$export$2a8244c81400d030, {
            hasSucceeded: hasSucceeded,
            hasFailed: hasFailed,
            hasAborted: hasAborted,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$3f502b146aa35f1d$export$be2c49f6982d0964.defaultProps = {
    hasSucceeded: false,
    hasFailed: false,
    hasAborted: false,
    ...(0, $8yne0.defaultProps)
};

});
parcelRegister("8yne0", function(module, exports) {

$parcel$export(module.exports, "defaultProps", () => $5dea2532a904de15$export$9c21a3269931e1e6);
$parcel$export(module.exports, "ExperienceTracker", () => $5dea2532a904de15$export$12b6b072930fd68f);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $gUUjF = parcelRequire("gUUjF");

var $1YJkI = parcelRequire("1YJkI");

var $diBcB = parcelRequire("diBcB");
const $5dea2532a904de15$export$9c21a3269931e1e6 = {
    failureEventAttributes: null,
    parentProviders: null,
    children: null
};
const $5dea2532a904de15$export$12b6b072930fd68f = ({ children: children, ...props })=>{
    const context = (0, $eUqFw.useContext)((0, $1YJkI.default));
    (0, $eUqFw.useEffect)(()=>{
        if (context === null) (0, $gUUjF.default).safeErrorWithoutCustomerData('experience-tracker.missing-provider', 'Experience tracker rendered without a provider');
    }, [
        context
    ]);
    if (context == null || false) return typeof children === 'function' ? children({
        onExperienceSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onExperienceFailure: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onExperienceAbort: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diBcB.default), {
        location: props.location,
        experienceContext: context,
        failureEventAttributes: props.failureEventAttributes,
        parentProvidersWhitelist: props.parentProviders
    }, children);
};
$5dea2532a904de15$export$12b6b072930fd68f.defaultProps = $5dea2532a904de15$export$9c21a3269931e1e6;

});
parcelRegister("1YJkI", function(module, exports) {

$parcel$export(module.exports, "default", () => $8931f37b247d5c7c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $8931f37b247d5c7c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});

parcelRegister("diBcB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2732e6c933c1686$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $JRB5w = parcelRequire("JRB5w");
class $f2732e6c933c1686$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.onSuccess = ()=>{
            // This guards against the possibility of the child calling `onExperienceSuccess` repeatedly.
            if (!this.hasSignalledSuccess && this.isReportingToCurrentProvider()) {
                this.hasSignalledSuccess = true;
                this.props.experienceContext.consumerCallbacks.onSuccess();
            }
        };
        this.onFailure = (locationSuffix, extraFailureEventAttributes)=>{
            const { experienceContext: { consumerCallbacks: { onFailure: onFailure } }, location: location, failureEventAttributes: failureEventAttributes } = this.props;
            if (!this.hasSignalledFailure && this.isReportingToCurrentProvider()) {
                this.hasSignalledFailure = true;
                const concatenatedLocation = locationSuffix == null ? location : `${location}.${locationSuffix}`;
                const mergedFailureAttributes = {
                    ...extraFailureEventAttributes,
                    ...failureEventAttributes
                };
                onFailure(concatenatedLocation, mergedFailureAttributes);
            }
        };
        this.onAbort = (locationSuffix, extraFailureEventAttributes)=>{
            const { experienceContext: { consumerCallbacks: { onAbort: onAbort } }, location: location, failureEventAttributes: failureEventAttributes } = this.props;
            if (!this.hasSignalledFailure && this.isReportingToCurrentProvider()) {
                this.hasSignalledFailure = true;
                const concatenatedLocation = locationSuffix == null ? location : `${location}.${locationSuffix}`;
                const mergedFailureAttributes = {
                    ...extraFailureEventAttributes,
                    ...failureEventAttributes
                };
                onAbort(concatenatedLocation, mergedFailureAttributes);
            }
        };
        this.resetTracker();
    }
    componentDidCatch(error) {
        if (!(0, $JRB5w.isClientFetchError)(error)) this.onFailure(undefined, {
            errorMessage: error.message
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place. This app exists only to track
        // error/success metrics; we don't want to interfere with the app that's actually rendering UI.
        throw error;
    }
    isReportingToCurrentProvider() {
        const { experience: experience } = this.props.experienceContext;
        return(// parentProviders is an OPTIONAL whitelist. If not specified, then we are definitely reporting to the current experience
        this.parentProvidersWhitelistSet == null || // otherwise make sure we are currently in one of the listed experiences
        this.parentProvidersWhitelistSet.has(experience));
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetTracker() {
        this.hasSignalledFailure = false;
        this.hasSignalledSuccess = false;
        this.lastExperienceId = this.props.experienceContext.experienceId;
        // Must only respect updates to `parentProvidersWhitelist` when the experience resets, otherwise weird bugs can arise.
        // Eg: a component could call onSuccess when it never called onPending, this would result in premature experience successes.
        this.parentProvidersWhitelistSet = this.props.parentProvidersWhitelist ? new Set(this.props.parentProvidersWhitelist) : null;
        this.isReportingToCurrentProvider() && this.props.experienceContext.consumerCallbacks.onPending();
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.lastExperienceId !== this.props.experienceContext.experienceId) this.resetTracker();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        const { children: children } = this.props;
        return typeof children === 'function' ? children({
            onExperienceSuccess: this.onSuccess,
            onExperienceFailure: this.onFailure,
            onExperienceAbort: this.onAbort
        }) : children;
    }
}

});




parcelRegister("fsWj7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('ezUEt')
        ]);
        const value = parcelRequire('3QVxF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("ezUEt")
    ]).then(()=>parcelRequire('3QVxF'));
}

});
parcelRegister("chRvw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    const retry_state = {};
    module.exports = async function(id) {
        if (!globalThis.navigator.onLine) await new Promise((res)=>{
            const callback = ()=>(globalThis.removeEventListener('online', callback), res());
            globalThis.addEventListener('online', callback);
        });
        let bundle_src = (parcelRequire("bjqNS")).resolve(id);
        let src = bundle_src;
        retry_state[bundle_src] = retry_state[bundle_src] || {
            should_retry: false,
            param: undefined
        };
        if (retry_state[bundle_src].should_retry) retry_state[bundle_src].param = Date.now();
        if (retry_state[bundle_src].param) src = src + "?retry=" + retry_state[bundle_src].param;
        try {
            retry_state[bundle_src].should_retry = false;
            return await import(src);
        } catch (error) {
            retry_state[bundle_src].should_retry = true;
            throw error;
        }
    };
} else {
    "use strict";
    function load(id) {
        // eslint-disable-next-line no-undef
        return import((parcelRequire("bjqNS")).resolve(id));
    }
    module.exports = load;
}

});
parcelRegister("bjqNS", function(module, exports) {

$parcel$export(module.exports, "register", () => $83c642ad29ddccba$export$6503ec6e8aabbaf, (v) => $83c642ad29ddccba$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $83c642ad29ddccba$export$f7ad0328861e2f03, (v) => $83c642ad29ddccba$export$f7ad0328861e2f03 = v);
var $83c642ad29ddccba$export$6503ec6e8aabbaf;
var $83c642ad29ddccba$export$f7ad0328861e2f03;
"use strict";
var $83c642ad29ddccba$var$mapping = new Map();
function $83c642ad29ddccba$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$83c642ad29ddccba$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $83c642ad29ddccba$var$resolve(id) {
    var resolved = $83c642ad29ddccba$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$83c642ad29ddccba$export$6503ec6e8aabbaf = $83c642ad29ddccba$var$register;
$83c642ad29ddccba$export$f7ad0328861e2f03 = $83c642ad29ddccba$var$resolve;

});




parcelRegister("fee69", function(module, exports) {

$parcel$export(module.exports, "ErrorFlagRenderer", () => $84532f65f3b96045$export$71d5b03f33fc194b);
$parcel$export(module.exports, "ErrorBoundaryFlag", () => $84532f65f3b96045$export$7b744ef274d5ae99);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");
parcelRequire("ciZ8Y");
var $5GxEP = parcelRequire("5GxEP");

var $aR8n6 = parcelRequire("aR8n6");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $84532f65f3b96045$var$ErrorFlagRendererLazy = (0, $7rh0R.lazy)(()=>(parcelRequire("l9gfJ")), {
    moduleId: "./src/packages/platform/ui/error-flag-renderer/src/ui/index.tsx"
});
const $84532f65f3b96045$export$71d5b03f33fc194b = (props)=>{
    const packageDetails = {
        id: 'asyncErrorFlagComponent',
        packageName: 'jiraErrorBoundary'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), packageDetails, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        teamName: "magma",
        ...packageDetails
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-error-flag-renderer",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($84532f65f3b96045$var$ErrorFlagRendererLazy, props))));
};
const $84532f65f3b96045$var$renderErrorFlag = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($84532f65f3b96045$export$71d5b03f33fc194b, {
        id: "error-boundary",
        error: error
    });
const $84532f65f3b96045$export$7b744ef274d5ae99 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        ...props,
        render: $84532f65f3b96045$var$renderErrorFlag
    }, children);
$84532f65f3b96045$export$7b744ef274d5ae99.defaultProps = {
    extraEventData: {},
    id: undefined
};

});
parcelRegister("l9gfJ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('83Xs8');
        const value = parcelRequire('e90Ot');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("83Xs8").then(()=>parcelRequire('e90Ot'));
}

});


parcelRegister("bEZRh", function(module, exports) {

$parcel$export(module.exports, "JSErrorPageAsync", () => $10484e99dcd11f12$export$f5794426a1f1dedd);
$parcel$export(module.exports, "NotFoundErrorPageAsync", () => $10484e99dcd11f12$export$8dd04806a5b061d8);
$parcel$export(module.exports, "DashboardPermissionErrorPageAsync", () => $10484e99dcd11f12$export$ee1615eb116a1e9e);
$parcel$export(module.exports, "WallboardPermissionErrorPageAsync", () => $10484e99dcd11f12$export$32e11a9f76e3adb);
$parcel$export(module.exports, "GenericPermissionErrorPageAsync", () => $10484e99dcd11f12$export$d9c0e71eccb9dcb3);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $10484e99dcd11f12$var$LazyJSErrorPage = (0, $7rh0R.lazy)(()=>(parcelRequire("lSQdY")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/js-error-page/index.tsx"
});
const $10484e99dcd11f12$export$f5794426a1f1dedd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-js-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10484e99dcd11f12$var$LazyJSErrorPage, props));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $10484e99dcd11f12$var$LazyNotFoundErrorPage = (0, $7rh0R.lazy)(()=>(parcelRequire("2oLEv")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/not-found-error-page/index.tsx"
});
const $10484e99dcd11f12$export$8dd04806a5b061d8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-not-found-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10484e99dcd11f12$var$LazyNotFoundErrorPage, null));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $10484e99dcd11f12$var$LazyDashboardPermissionErrorPage = (0, $7rh0R.lazy)(()=>(parcelRequire("k2Qsb")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/dashboard-permission-error-page/index.tsx"
});
const $10484e99dcd11f12$export$ee1615eb116a1e9e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-dashboard-permission-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10484e99dcd11f12$var$LazyDashboardPermissionErrorPage, null));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $10484e99dcd11f12$var$LazyWallboardPermissionErrorPage = (0, $7rh0R.lazy)(()=>(parcelRequire("aY0K5")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/wallboard-permission-error-page/index.tsx"
});
const $10484e99dcd11f12$export$32e11a9f76e3adb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-wallboard-permission-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10484e99dcd11f12$var$LazyWallboardPermissionErrorPage, null));

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $10484e99dcd11f12$var$LazyGenericPermissionErrorPage = (0, $7rh0R.lazy)(()=>(parcelRequire("9AbzV")), {
    moduleId: "./src/packages/platform/ui/error-pages/src/ui/generic-permission-error-page/index.tsx"
});
const $10484e99dcd11f12$export$d9c0e71eccb9dcb3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-generic-permission-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10484e99dcd11f12$var$LazyGenericPermissionErrorPage, null));

});
parcelRegister("lSQdY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('dsiAd'),
            load('92sUi'),
            load('i5RRW'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('iiJ9w')
        ]);
        const value = parcelRequire('51Bn3');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("dsiAd"),
        load("92sUi"),
        load("i5RRW"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("iiJ9w")
    ]).then(()=>parcelRequire('51Bn3'));
}

});

parcelRegister("2oLEv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('92sUi'),
            load('i5RRW'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('jmrYP')
        ]);
        const value = parcelRequire('iDwZs');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("92sUi"),
        load("i5RRW"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("jmrYP")
    ]).then(()=>parcelRequire('iDwZs'));
}

});

parcelRegister("k2Qsb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('92sUi'),
            load('i5RRW'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('jYp09')
        ]);
        const value = parcelRequire('eU3fc');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("92sUi"),
        load("i5RRW"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("jYp09")
    ]).then(()=>parcelRequire('eU3fc'));
}

});

parcelRegister("aY0K5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('92sUi'),
            load('i5RRW'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('4EI3a')
        ]);
        const value = parcelRequire('emPyJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("92sUi"),
        load("i5RRW"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("4EI3a")
    ]).then(()=>parcelRequire('emPyJ'));
}

});

parcelRegister("9AbzV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('92sUi'),
            load('i5RRW'),
            load('hPzOn'),
            load('2hmUs'),
            load('bCeK4'),
            load('j1Sj6')
        ]);
        const value = parcelRequire('k1QCL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("92sUi"),
        load("i5RRW"),
        load("hPzOn"),
        load("2hmUs"),
        load("bCeK4"),
        load("j1Sj6")
    ]).then(()=>parcelRequire('k1QCL'));
}

});




parcelRegister("6iz4v", function(module, exports) {

$parcel$export(module.exports, "getMark", () => $4ea065c8119ae170$export$f45af69d005a6ed);
$parcel$export(module.exports, "setMark", () => $4ea065c8119ae170$export$f7a1fb90d8604165);
$parcel$export(module.exports, "setMeasure", () => $4ea065c8119ae170$export$3d472a4be9f2b366);
$parcel$export(module.exports, "measureFunc", () => $4ea065c8119ae170$export$25a311d3df56652d);
/* eslint-disable no-console */ 
var $hgcvd = parcelRequire("hgcvd");
const $4ea065c8119ae170$export$f45af69d005a6ed = (markName)=>{
    if (!(0, $hgcvd.default).getEntriesByName) return null;
    const marks = (0, $hgcvd.default).getEntriesByName(markName) || [];
    return marks.length > 0 ? marks[0] : null;
};
const $4ea065c8119ae170$export$f7a1fb90d8604165 = (markName, markOptions)=>{
    if (!(0, $hgcvd.default).mark) return undefined;
    const entry = (0, $hgcvd.default).mark(markName, markOptions);
    if (console.timeStamp) console.timeStamp(markName);
    return entry;
};
const $4ea065c8119ae170$export$3d472a4be9f2b366 = (measureName, start, end)=>{
    // performance.measure will throw an exception if either start/end marks are not set
    try {
        return (0, $hgcvd.default).measure(measureName, start, end);
    // eslint-disable-next-line no-empty
    } catch (_err) {}
    return undefined;
};
function $4ea065c8119ae170$export$25a311d3df56652d(measureName, func) {
    $4ea065c8119ae170$export$f7a1fb90d8604165(`${measureName}:start`);
    const result = func();
    $4ea065c8119ae170$export$f7a1fb90d8604165(`${measureName}:end`);
    $4ea065c8119ae170$export$3d472a4be9f2b366(measureName, `${measureName}:start`, `${measureName}:end`);
    return result;
}

});
parcelRegister("hgcvd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d50611601f2822a3$export$2e2bcd8739ae039);
/* eslint-disable no-restricted-properties */ 
var $jG2Eu = parcelRequire("jG2Eu");
const $d50611601f2822a3$var$getPerf = ()=>{
    try {
        // TODO - Write up an explanation to why we are doing this, if this method is approved.
        window.performance.clearResourceTimings && (window.performance.clearResourceTimings = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))));
        return window.performance;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        // no op implementation
        return {
            now: ()=>0,
            mark: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            clearMarks: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            clearResourceTimings: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
            getEntriesByType: (_type)=>[],
            getEntriesByName: (_name)=>[],
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            measure: (_measureName, _start, _end)=>{}
        };
    }
};
var $d50611601f2822a3$export$2e2bcd8739ae039 = $d50611601f2822a3$var$getPerf();

});


parcelRegister("ICvxP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dab3f6273aaa3f2$export$2e2bcd8739ae039);

var $hgcvd = parcelRequire("hgcvd");
var /*
 * This utility finds all performance entries that is prefixed
 * with the `prefix` and does clearMarks on each entry.
 * All the entries that are cleared will be returned
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$5dab3f6273aaa3f2$export$2e2bcd8739ae039 = (prefix)=>{
    // @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    if ((0, $hgcvd.default) && (0, $hgcvd.default).getEntries && (0, $hgcvd.default).clearMarks) return (0, $hgcvd.default)// @ts-expect-error - TS2339 - Property 'getEntries' does not exist on type 'Performance | { now: () => number; mark: (...args: any[]) => void; clearMarks: (...args: any[]) => void; clearResourceTimings: (...args: any[]) => void; getEntriesByType: (type: string) => never[]; getEntriesByName: (name: string) => never[]; }'.
    .getEntries()// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .filter((mark)=>mark.name.startsWith(prefix))// @ts-expect-error - TS7006 - Parameter 'mark' implicitly has an 'any' type.
    .map((mark)=>{
        (0, $hgcvd.default).clearMarks(mark.name);
        return mark;
    });
    return [];
};

});

parcelRegister("8uNQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7b717ff17f28957$export$2e2bcd8739ae039);

var $hgcvd = parcelRequire("hgcvd");

var $6iz4v = parcelRequire("6iz4v");

var $8ITzY = parcelRequire("8ITzY");

var $ICvxP = parcelRequire("ICvxP");

var $h97Af = parcelRequire("h97Af");

var $a7b717ff17f28957$export$2e2bcd8739ae039 = (0, $hgcvd.default);

});
parcelRegister("8ITzY", function(module, exports) {

$parcel$export(module.exports, "timeBetweenMarks", () => $bf8e4b1e21537136$export$9c25bf1893ba64c);

var $6iz4v = parcelRequire("6iz4v");
const $bf8e4b1e21537136$export$9c25bf1893ba64c = (startMarkName, endMarkName)=>{
    const startMark = (0, $6iz4v.getMark)(startMarkName);
    const endMark = (0, $6iz4v.getMark)(endMarkName);
    if (!startMark || !endMark || startMark.startTime > endMark.startTime) return null;
    return endMark.startTime - startMark.startTime;
};

});

parcelRegister("h97Af", function(module, exports) {

$parcel$export(module.exports, "default", () => $97ef913b7770c56a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6iz4v = parcelRequire("6iz4v");
const $97ef913b7770c56a$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
    const renderRef = (0, $eUqFw.useRef)(false);
    if (!renderRef.current) {
        renderRef.current = true;
        (0, $6iz4v.setMark)(metricKey);
        onSet && onSet();
    }
    return null;
};
var $97ef913b7770c56a$export$2e2bcd8739ae039 = $97ef913b7770c56a$var$PerformanceMark;

});


parcelRegister("a5pCl", function(module, exports) {

$parcel$export(module.exports, "initBrowserMetrics3", () => $ff039675aaf63314$export$156d1d35be797a9d);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $1ybV0 = parcelRequire("1ybV0");

var $aWbzA = parcelRequire("aWbzA");

var $6rW04 = parcelRequire("6rW04");

var $lCenZ = parcelRequire("lCenZ");

var $3FyZ4 = parcelRequire("3FyZ4");

var $12kyE = parcelRequire("12kyE");
var $aPkDp = parcelRequire("aPkDp");
var $eHCgh = parcelRequire("eHCgh");

var $jzMSJ = parcelRequire("jzMSJ");

var $d98Xv = parcelRequire("d98Xv");

var $ddJch = parcelRequire("ddJch");

var $g1qOr = parcelRequire("g1qOr");

var $8a2x3 = parcelRequire("8a2x3");

var $1AO5V = parcelRequire("1AO5V");

var $4230y = parcelRequire("4230y");

var $cq4ut = parcelRequire("cq4ut");
var $giMpj = parcelRequire("giMpj");

var $7tRvw = parcelRequire("7tRvw");
const $ff039675aaf63314$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
const $ff039675aaf63314$var$getWRMAssetName = (url)=>{
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = (0, $lCenZ.sanitiseAssetName)(false)(url);
    if (!resources) return assetName;
    return `wrm/${resources}/${assetName}`;
};
const $ff039675aaf63314$var$getFileName = (url)=>$ff039675aaf63314$var$isWRMResource(url) ? $ff039675aaf63314$var$getWRMAssetName(url) : (0, $lCenZ.sanitiseAssetName)(false)(url);
const $ff039675aaf63314$export$156d1d35be797a9d = ()=>{
    (0, $giMpj.startLSObserver)();
    (0, $giMpj.startLTObserver)();
    const info = {
        product: 'jira',
        app: {
            version: {
                web: window.BUILD_KEY,
                ssr: window.SSR_BUILD_KEY
            },
            framework: {
                name: 'react',
                version: $eUqFw.version
            }
        },
        region: (0, $6rW04.default)('ajs-region') || 'unknown'
    };
    const endpoints = {
        eventPipelineClient: (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const instance = client.getInstance();
            if (!(0, $1ybV0.ff)('uip.bm3.stop-page-load')) return instance;
            return {
                sendOperationalEvent: (payload)=>{
                    const type = payload?.attributes?.properties?.['event:type'];
                    if (type === 'page-load') return;
                    return instance.sendOperationalEvent(payload);
                }
            };
        })
    };
    const resourceTimings = {
        sanitiseEndpoints: $g1qOr.sanitiseEndpoints,
        mapResources: $ff039675aaf63314$var$getFileName,
        hasTimingHeaders: (url)=>url.includes('jira-frontend-static') || url.includes('jira-frontend-branch') || $ff039675aaf63314$var$isWRMResource(url),
        // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
        xhrFilter: (url)=>url.includes('/rest/greenhopper/')
    };
    const featureFlagClient = {
        getValue: (featureFlagName)=>{
            const allFeatureFlags = (0, $aWbzA.default)();
            if (!allFeatureFlags) return undefined;
            return allFeatureFlags[featureFlagName]?.value;
        }
    };
    const featureFlags = {
        client: Promise.resolve(featureFlagClient)
    };
    const plugins = {
        featureFlags: featureFlags,
        resourceTimings: resourceTimings,
        bundleEvalTimings: $jzMSJ.bundleEvalTimings
    };
    if ((0, $1ybV0.ff)('uip.ufo')) (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        (0, $aPkDp.payloadPublisher).setup({
            product: 'jira',
            app: {
                version: {
                    web: window.BUILD_KEY,
                    ssr: window.SSR_BUILD_KEY
                },
                framework: {
                    name: 'react',
                    version: $eUqFw.version
                }
            },
            region: (0, $6rW04.default)('ajs-region') || 'unknown',
            tenantType: (0, $6rW04.default)('ajs-is-synthetic') === 'true' ? (0, $eHCgh.TenantType).Synthetic : (0, $eHCgh.TenantType).RealUser,
            gasv3: client.getInstance(),
            bundleEvalTimings: // @ts-expect-error - TS2322 - Type '{ readonly mapPerformanceMark: (mark: string) => { name: string; type: string; } | null; }' is not assignable to type 'BundleEvalTimingsConfig'.
            $jzMSJ.bundleEvalTimings,
            resourceTimings: resourceTimings,
            featureFlagClient: // @ts-expect-error - TS2322 - Type '{ getValue: (featureFlagName: string) => FeatureFlagValue | undefined; }' is not assignable to type 'FeatureFlagClient'.
            featureFlagClient,
            featureFlags: [
                ...(0, $8a2x3.featureFlagsAddedToEVERYJiraEvent),
                ...(0, $4230y.jfpPerfFeatureFlags),
                ...(0, $1AO5V.featureFlagsAddedToEVERYPageLoadEvent)
            ],
            plugins: [
                // all
                (0, $d98Xv.getCustomData),
                // @ts-expect-error - TS2322 - Type '(data: {    start: number;}) => Record<string, any> | null' is not assignable to type '(data: ExperienceData | PageLoadExperienceData) => CustomData | null'.
                (0, $g1qOr.getMarks),
                (0, $g1qOr.getMemoryMetrics),
                // page-load
                (0, $ddJch.getPageSizeMetrics),
                (0, $ddJch.getExtraNavigationTimings),
                // @ts-expect-error - TS2322 - Type '() => (() => unknown)[]' is not assignable to type '(data: ExperienceData | PageLoadExperienceData) => CustomData | null'.
                (0, $g1qOr.getPageLoadPlugins)
            ],
            ssr: $7tRvw.ssr,
            performanceConfig: {
                histogram: {
                    [(0, $12kyE.ExperiencePerformanceTypes).PageLoad]: {
                        initial: {
                            fmp: '2500_3000_3500_4000_5000_6000',
                            tti: '4000_4500_5000_6000_7000_8000_9000'
                        },
                        transition: {
                            fmp: '2500_3000_3500_4000_5000_6000',
                            tti: '2500_3000_3500_4000_5000_6000'
                        }
                    },
                    [(0, $12kyE.ExperiencePerformanceTypes).InlineResult]: {
                        result: '100_200_500_1000_1500',
                        response: '50_100_150_200_300_500'
                    },
                    [(0, $12kyE.ExperiencePerformanceTypes).Custom]: {
                        duration: '250_500_1000_1500_2000_3000_4000'
                    }
                }
            }
        });
    });
    (0, $acbV3.browserMetrics).init({
        info: info,
        endpoints: // @ts-expect-error - TS2322 - Type '{ eventPipelineClient: Promise<AnalyticsWebClient> | Promise<IEventPipelineClient>; metalClient: Promise<MetalClient>; }' is not assignable to type '{ eventPipelineClient: Promise<{ sendOperationalEvent: (payload: GasPurePayload) => void; }>; metalClient?: Promise<{ metric: { submit: (payload: unknown) => void; }; }> | undefined; }'.
        endpoints,
        plugins: // @ts-expect-error - TS2322 - Type '{ featureFlags: { client: Promise<{ getValue: (featureFlagName: string) => FeatureFlagValue | undefined; }>; }; resourceTimings: { sanitiseEndpoints: (url: string) => string; mapResources: (url: string) => any; hasTimingHeaders: (url: string) => boolean; xhrFilter: (url: any) => any; }; bundleEvalTimings: { ...; }; }' is not assignable to type '{ resourceTimings: ResourceTimingsConfig; bundleEvalTimings?: BundleEvalTimingsConfig | undefined; featureFlags: { client: FeatureFlagsClientPromise; }; }'.
        plugins,
        events: {
            all: {
                featureFlags: [
                    ...(0, $8a2x3.featureFlagsAddedToEVERYJiraEvent),
                    ...(0, $4230y.jfpPerfFeatureFlags)
                ],
                plugins: [
                    (0, $g1qOr.getMarks),
                    (0, $g1qOr.getMemoryMetrics),
                    (0, $cq4ut.getLighthouseMetrics),
                    (0, $d98Xv.newGetCustomData)
                ]
            },
            PAGE_LOAD: {
                featureFlags: [
                    ...(0, $1AO5V.featureFlagsAddedToEVERYPageLoadEvent)
                ],
                custom: {
                    ...(0, $ddJch.getPageSizeMetrics)(),
                    ...(0, $ddJch.getExtraNavigationTimings)()
                },
                // @ts-expect-error - TS2322 - Type '(() => unknown)[]' is not assignable to type 'CustomPlugin[]'.
                plugins: (0, $g1qOr.getPageLoadPlugins)(),
                histogram: {
                    initial: {
                        fmp: '2500_3000_3500_4000_5000_6000',
                        tti: '4000_4500_5000_6000_7000_8000_9000'
                    },
                    transition: {
                        fmp: '2500_3000_3500_4000_5000_6000',
                        tti: '2500_3000_3500_4000_5000_6000'
                    }
                }
            },
            INLINE_RESULT: {
                histogram: {
                    result: '100_200_500_1000_1500',
                    response: '50_100_150_200_300_500'
                }
            },
            CUSTOM: {
                histogram: {
                    duration: '250_500_1000_1500_2000_3000_4000'
                }
            },
            WEB_VITALS: {
                enabled: !false && (0, $6rW04.default)('ajs-is-synthetic') === 'true'
            }
        },
        // @ts-expect-error - TS2322 - Type '{ readonly includeFeatureFlags: "when-available"; readonly getDoneMark: () => number | null; readonly getTimings: () => any; readonly getFeatureFlags: MemoizedFn<() => any>; }' is not assignable to type 'SSRConfig'.
        ssr: (0, $7tRvw.ssrExtended)
    });
    (0, $acbV3.browserMetrics).startPageLoad({
        isInitial: true
    });
};

});
parcelRegister("jzMSJ", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", () => $51716dc230d07393$export$1a2bb347935fc536);

var $hknOo = parcelRequire("hknOo");
const $51716dc230d07393$export$1a2bb347935fc536 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $hknOo.JS_EVAL_START))) return {
            name: mark.substring(0, mark.indexOf((0, $hknOo.JS_EVAL_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $hknOo.JS_EVAL_STOP))) return {
            name: mark.substring(0, mark.indexOf((0, $hknOo.JS_EVAL_STOP))),
            type: 'end'
        };
        return null;
    }
};

});

parcelRegister("d98Xv", function(module, exports) {

$parcel$export(module.exports, "newGetCustomData", () => $0494989faf4b1072$export$bc962f7892f5542c);
$parcel$export(module.exports, "getCustomData", () => $0494989faf4b1072$export$c740a965f4a07e8e);

var $jqvCZ = parcelRequire("jqvCZ");

var $5iWql = parcelRequire("5iWql");

var $6rW04 = parcelRequire("6rW04");

var $jzUMl = parcelRequire("jzUMl");

var $gQEut = parcelRequire("gQEut");

var $2Lywh = parcelRequire("2Lywh");

var $lldsH = parcelRequire("lldsH");
const $0494989faf4b1072$var$customData = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const commonCustomData = {};
    const shard = (0, $6rW04.default)('ajs-shard');
    if (shard !== null && shard !== '') commonCustomData.shard = shard;
    commonCustomData['network:assetEncoding'] = (0, $jzUMl.getAssetEncoding)();
    const buildVariant = (0, $gQEut.getBuildVariant)();
    if (buildVariant) commonCustomData['app:buildVariant'] = buildVariant;
    const bundlerVersion = (0, $2Lywh.getBundlerVersion)();
    if (bundlerVersion) commonCustomData['app:bundlerVersion'] = bundlerVersion;
    const useBifrostGateway = (0, $lldsH.getUseBifrostGateway)();
    if (useBifrostGateway) commonCustomData['app:useBifrostGateway'] = useBifrostGateway;
    commonCustomData.httpProtocol = performance.getEntriesByType('resource')// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'. | TS2339 - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    .find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
    return commonCustomData;
};
const $0494989faf4b1072$export$bc962f7892f5542c = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))($0494989faf4b1072$var$customData, ()=>true);
const $0494989faf4b1072$export$c740a965f4a07e8e = (0, $5iWql.default)($0494989faf4b1072$var$customData);

});
parcelRegister("jzUMl", function(module, exports) {

$parcel$export(module.exports, "getAssetEncoding", () => $b876e90fe5293a48$export$fd12d8f45e126585);
const $b876e90fe5293a48$export$fd12d8f45e126585 = ()=>{
    const assetEncodings = Array.prototype.map.call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, i)=>{
        // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
        acc[i] = true;
        return acc;
    }, {});
    const uniqueEncodings = Object.keys(assetEncodings).sort();
    let result = 'unknown';
    if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
    if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
    return result;
};

});

parcelRegister("gQEut", function(module, exports) {

$parcel$export(module.exports, "getBuildVariant", () => $3574940cc30d9b67$export$ca0c40b5b7c3b911);
const $3574940cc30d9b67$export$ca0c40b5b7c3b911 = ()=>window.BUILD_VARIANT;

});

parcelRegister("2Lywh", function(module, exports) {

$parcel$export(module.exports, "getBundlerVersion", () => $b56da1b40d72ec46$export$5dca7b2a9cf4f500);
const $b56da1b40d72ec46$export$5dca7b2a9cf4f500 = ()=>window.BUNDLER_VERSION;

});

parcelRegister("lldsH", function(module, exports) {

$parcel$export(module.exports, "getUseBifrostGateway", () => $5e154bf79a7b281f$export$e2e4644f912a860c);
const $5e154bf79a7b281f$export$e2e4644f912a860c = ()=>window.USE_BIFROST_GATEWAY;

});


parcelRegister("ddJch", function(module, exports) {

$parcel$export(module.exports, "getPageSizeMetrics", () => $639bd7f576fe9bd6$export$84e3d676f1564c75);
$parcel$export(module.exports, "getExtraNavigationTimings", () => $639bd7f576fe9bd6$export$b37a70af06e58097);
$parcel$export(module.exports, "getPageSizeInfo", () => $639bd7f576fe9bd6$export$b72e035af6568be7);

var $8uNQc = parcelRequire("8uNQc");
const $639bd7f576fe9bd6$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) // @ts-expect-error - TS2345 - Argument of type 'ShadowRoot' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $639bd7f576fe9bd6$export$b37a70af06e58097 = ()=>{
    if (!(0, $8uNQc.default)) return {};
    const navigation = (0, $8uNQc.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        // @ts-expect-error - TS2339 - Property 'decodedBodySize' does not exist on type 'PerformanceEntry'.
        decodedBodySize: navigation.decodedBodySize,
        // @ts-expect-error - TS2339 - Property 'encodedBodySize' does not exist on type 'PerformanceEntry'.
        encodedBodySize: navigation.encodedBodySize,
        // @ts-expect-error - TS2339 - Property 'transferSize' does not exist on type 'PerformanceEntry'.
        transferSize: navigation.transferSize
    };
};
const $639bd7f576fe9bd6$var$assetsTypes = [
    'script',
    'link'
];
const $639bd7f576fe9bd6$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $639bd7f576fe9bd6$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const entry of (0, $8uNQc.default).getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($639bd7f576fe9bd6$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    return returnValue;
};

});

parcelRegister("g1qOr", function(module, exports) {

$parcel$export(module.exports, "getPageLoadPlugins", () => $5322cf70d39f6f86$export$4d5c3be18e81b958);
$parcel$export(module.exports, "getMemoryMetrics", () => $5322cf70d39f6f86$export$500422125b861bab);
$parcel$export(module.exports, "getMarks", () => $5322cf70d39f6f86$export$9d952633c9c2237b);
$parcel$export(module.exports, "sanitiseEndpoints", () => $5322cf70d39f6f86$export$6dfc8bfc2349f367);

var $k4nIh = parcelRequire("k4nIh");

var $llxpa = parcelRequire("llxpa");

var $hknOo = parcelRequire("hknOo");

var $8iunV = parcelRequire("8iunV");

var $1l606 = parcelRequire("1l606");

var $ddJch = parcelRequire("ddJch");

var $hBcvH = parcelRequire("hBcvH");

var $i9WH3 = parcelRequire("i9WH3");

var $jCRxW = parcelRequire("jCRxW");

var $eUjOn = parcelRequire("eUjOn");
const $5322cf70d39f6f86$var$endpointsWithOperationNameRegex = new RegExp('/rest/graphql/1/|/rest/gira/1/|/gateway/api/graphql|/jsw2/graphql');
const $5322cf70d39f6f86$export$4d5c3be18e81b958 = ()=>{
    const pageLoadCustomData = [];
    pageLoadCustomData.push((data)=>{
        // initial load only
        const startTime = data?.start || data?.result?.startTime || 0;
        if (startTime !== 0) return {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return Object.entries((0, $1l606.getServerDurationMetrics)()).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            acc[key] = value;
            return acc;
        }, {});
    });
    pageLoadCustomData.push((0, $jCRxW.getRouterResourceMetrics));
    pageLoadCustomData.push((0, $eUjOn.getWRMStats));
    pageLoadCustomData.push((0, $hBcvH.getCacheHitRatio));
    pageLoadCustomData.push((0, $i9WH3.getCHRInfo));
    pageLoadCustomData.push((0, $ddJch.getPageSizeInfo));
    return pageLoadCustomData;
};
const $5322cf70d39f6f86$export$500422125b861bab = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customData = {};
    const memoryUsageReport = (0, $8iunV.getMemoryUsageReport)();
    if (memoryUsageReport) customData.memory = memoryUsageReport;
    return customData;
};
const $5322cf70d39f6f86$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $llxpa.getUserTiming)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    // @ts-expect-error - TS7031 - Binding element 'baseName' implicitly has an 'any' type. | TS7031 - Binding element 'collection' implicitly has an 'any' type.
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter(// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    (item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, $hknOo.JS_EVAL_START)) && !item.name.endsWith((0, $hknOo.JS_EVAL_STOP)) && item.startTime >= data.start)// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    .forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};
const $5322cf70d39f6f86$export$6dfc8bfc2349f367 = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, true);
    let fileName = parsedUrl.pathname.replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/i, '<uuid>').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
    .replace(/\/\d+$/i, '/<id>');
    /**
	 * For these endpoints we make a special exception to add the query parameters so that we can distinguish calls using different queries
	 */ if ($5322cf70d39f6f86$var$endpointsWithOperationNameRegex.test(fileName)) {
        const { operation: operation } = parsedUrl.query;
        if (operation) fileName += `?operation=${operation}`;
    }
    return fileName;
};

});
parcelRegister("8iunV", function(module, exports) {

$parcel$export(module.exports, "getMemoryUsageReport", () => $4fa46aa13a679f59$export$e5bd2d61c7c80651);
// This is an approximation of the start of the session
const $4fa46aa13a679f59$var$sessionStart = Date.now();
const $4fa46aa13a679f59$export$e5bd2d61c7c80651 = ()=>{
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    if (typeof performance === 'undefined' || performance?.memory == null) return null;
    const now = Date.now();
    const sessionTime = now - $4fa46aa13a679f59$var$sessionStart;
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
    return {
        sessionTime: sessionTime,
        performanceMemoryEntry: {
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize
        }
    };
};

});

parcelRegister("1l606", function(module, exports) {

$parcel$export(module.exports, "getServerDurationMetrics", () => $b6f44c5a5e85fd70$export$efd8b60b870e5282);
/**
 * Extracts and compiles key performance metrics from the DOM to assess server response times and request handling efficiency.
 * This includes metrics like server duration, trace IDs, concurrency levels, and timing details, which are crucial for analyzing server behavior and identifying potential bottlenecks.
 */ const $b6f44c5a5e85fd70$export$efd8b60b870e5282 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const metrics = {};
    try {
        // server duration metric is buried in a hidden form near end of </body>
        const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
        if (serverDurationElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverDuration = Number(serverDurationElem.value);
            if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
        }
        const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
        if (serverTraceIdElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceId = serverTraceIdElem.value;
            metrics.serverRequestTraceId = serverRequestTraceId;
        }
        const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
        if (serverTraceSampledElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceSampled = serverTraceSampledElem.value;
            switch(serverRequestTraceSampled){
                case 'true':
                    metrics.serverRequestTraceSampled = true;
                    break;
                case 'false':
                    metrics.serverRequestTraceSampled = false;
                    break;
                default:
                    metrics.serverRequestTraceSampled = null;
                    break;
            }
        }
        const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
        if (concurrentRequestsElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const concurrentRequests = concurrentRequestsElem.value;
            metrics.concurrentRequests = concurrentRequests;
        }
        const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
        if (serverRequestStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestStartTime = serverRequestStartTimeElem.value;
            metrics.serverRequestStartTime = serverRequestStartTime;
        }
        const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
        if (frontendFlushStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const frontendFlushStartTime = frontendFlushStartTimeElem.value;
            metrics.frontendFlushStartTime = frontendFlushStartTime;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ignored) {
    /* noop */ }
    return metrics;
};

});

parcelRegister("hBcvH", function(module, exports) {

$parcel$export(module.exports, "getCacheHitRatio", () => $f97943b49460b142$export$e8a9322c3d9da8a6);

var $8uNQc = parcelRequire("8uNQc");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $f97943b49460b142$var$cacheableTypes = [
    'script',
    'link'
];
const $f97943b49460b142$var$CACHE_NETWORK = 'network';
const $f97943b49460b142$var$CACHE_MEMORY = 'memory';
const $f97943b49460b142$var$CACHE_DISK = 'disk';
const $f97943b49460b142$var$calculateTransferType = (type, duration, size)=>{
    if (!$f97943b49460b142$var$cacheableTypes.includes(type)) return $f97943b49460b142$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $f97943b49460b142$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $f97943b49460b142$var$CACHE_DISK;
    if (size === undefined) return null;
    return $f97943b49460b142$var$CACHE_NETWORK;
};
const $f97943b49460b142$export$e8a9322c3d9da8a6 = ({ start: start })=>{
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $8uNQc.default).getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $f97943b49460b142$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
};

});

parcelRegister("i9WH3", function(module, exports) {

$parcel$export(module.exports, "getCHRInfo", () => $94e8de10d1194822$export$9e005e111be93521);

var $8uNQc = parcelRequire("8uNQc");

var $RMoAZ = parcelRequire("RMoAZ");

var $jkxDC = parcelRequire("jkxDC");
const $94e8de10d1194822$export$9e005e111be93521 = ({ start: start })=>{
    // initial load only
    if (start !== 0) return {};
    const ssrMark = (0, $RMoAZ.getSSRMark)();
    const reporter = new (0, $jkxDC.CHRReporter)(ssrMark);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $8uNQc.default).getEntriesByType('resource'))reporter.add(entry);
        const chr = reporter.get();
        return chr === null ? {} : {
            chr: chr
        };
    } catch (e) {
        return {};
    }
};

});
parcelRegister("RMoAZ", function(module, exports) {

$parcel$export(module.exports, "getSSRMark", () => $feacb06ea058cfe6$export$1faf7d001841a41c);

var $6iz4v = parcelRequire("6iz4v");

const $feacb06ea058cfe6$export$1faf7d001841a41c = ()=>(0, $6iz4v.getMark)((0, $37f655a4e4d5690e$export$135c96ab5afee429))?.startTime || null;

});
const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("jkxDC", function(module, exports) {

$parcel$export(module.exports, "CHRReporter", () => $d1513b0cdbe3f9c3$export$7d0d4cfb6455ffa5);

var $8S0tB = parcelRequire("8S0tB");

var $dskof = parcelRequire("dskof");
class $d1513b0cdbe3f9c3$export$7d0d4cfb6455ffa5 {
    constructor(ssrMark){
        this.preloaded = new (0, $dskof.CHRSummary)();
        this.all = new (0, $dskof.CHRSummary)();
        this.ssrMark = null;
        this.ssrMark = ssrMark;
    }
    add(item) {
        if (item.encodedBodySize === 0) return;
        if (item.initiatorType === 'link' && (0, $8S0tB.cacheableTypes).includes(item.initiatorType) && (this.ssrMark === null || item.startTime < this.ssrMark)) this.preloaded.add(item);
        this.all.add(item);
    }
    static round(n) {
        return Math.round(n * 10000) / 10000;
    }
    makePayload(summary) {
        const bundlesLoadType = {
            mem: $d1513b0cdbe3f9c3$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $dskof.CHRSummary).MEMORY_KEY] / summary.bundlesCount),
            disk: $d1513b0cdbe3f9c3$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $dskof.CHRSummary).DISK_KEY] / summary.bundlesCount),
            net: $d1513b0cdbe3f9c3$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $dskof.CHRSummary).NETWORK_KEY] / summary.bundlesCount)
        };
        const bundlesRatio = $d1513b0cdbe3f9c3$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, $dskof.CHRSummary).MEMORY_KEY] + summary.bundles[(0, $dskof.CHRSummary).DISK_KEY]) / summary.bundlesCount);
        const sizeLoadType = {
            mem: $d1513b0cdbe3f9c3$export$7d0d4cfb6455ffa5.round(summary.size[(0, $dskof.CHRSummary).MEMORY_KEY] / summary.sizeTotal),
            disk: $d1513b0cdbe3f9c3$export$7d0d4cfb6455ffa5.round(summary.size[(0, $dskof.CHRSummary).DISK_KEY] / summary.sizeTotal),
            net: $d1513b0cdbe3f9c3$export$7d0d4cfb6455ffa5.round(summary.size[(0, $dskof.CHRSummary).NETWORK_KEY] / summary.sizeTotal)
        };
        const sizeRatio = $d1513b0cdbe3f9c3$export$7d0d4cfb6455ffa5.round((summary.size[(0, $dskof.CHRSummary).MEMORY_KEY] + summary.size[(0, $dskof.CHRSummary).DISK_KEY]) / summary.sizeTotal);
        return {
            bundles: {
                ratio: bundlesRatio,
                count: summary.bundlesCount,
                loadType: bundlesLoadType
            },
            size: {
                ratio: sizeRatio,
                total: summary.sizeTotal,
                loadType: sizeLoadType
            }
        };
    }
    get() {
        if (this.all.bundlesCount === 0) return null;
        return {
            preloaded: this.makePayload(this.preloaded),
            all: this.makePayload(this.all)
        };
    }
}

});
parcelRegister("8S0tB", function(module, exports) {

$parcel$export(module.exports, "cacheableTypes", () => $0c7ca5be46ce511a$export$5e1aa91d6932ddaa);
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $0c7ca5be46ce511a$export$5e1aa91d6932ddaa = [
    'script',
    'link'
];

});

parcelRegister("dskof", function(module, exports) {

$parcel$export(module.exports, "CHRSummary", () => $576856e8fd08f6e5$export$783d6618ee601ba);

var $8S0tB = parcelRequire("8S0tB");
const $576856e8fd08f6e5$var$calculateTransferType = (type, duration, size)=>{
    if (!(0, $8S0tB.cacheableTypes).includes(type)) return null;
    if ((size === undefined || size === 0) && duration === 0) return $576856e8fd08f6e5$export$783d6618ee601ba.MEMORY_KEY;
    if (size === 0 && duration > 0) return $576856e8fd08f6e5$export$783d6618ee601ba.DISK_KEY;
    if (size === undefined) return null;
    return $576856e8fd08f6e5$export$783d6618ee601ba.NETWORK_KEY;
};
class $576856e8fd08f6e5$export$783d6618ee601ba {
    static{
        this.MEMORY_KEY = 'mem';
    }
    static{
        this.DISK_KEY = 'disk';
    }
    static{
        this.NETWORK_KEY = 'net';
    }
    add(item) {
        const type = $576856e8fd08f6e5$var$calculateTransferType(item.initiatorType, item.duration, item.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += item.encodedBodySize;
        this.sizeTotal += item.encodedBodySize;
    }
    constructor(){
        this.bundles = {
            [$576856e8fd08f6e5$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$576856e8fd08f6e5$export$783d6618ee601ba.DISK_KEY]: 0,
            [$576856e8fd08f6e5$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [$576856e8fd08f6e5$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$576856e8fd08f6e5$export$783d6618ee601ba.DISK_KEY]: 0,
            [$576856e8fd08f6e5$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.sizeTotal = 0;
    }
}

});



parcelRegister("jCRxW", function(module, exports) {

$parcel$export(module.exports, "getRouterResourceMetrics", () => $776230498e15518b$export$e703af446a67c7f4);
const $776230498e15518b$export$e703af446a67c7f4 = ()=>{
    const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
        if (key !== key.toUpperCase()) return false;
        const resource = window.SPA_STATE[key];
        if (typeof resource !== 'object') return false;
        const resourceResponse = resource[Object.keys(resource)[0]];
        return resourceResponse?.error?.name === 'TimeoutError';
    }) : [];
    return {
        ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
    };
};

});

parcelRegister("eUjOn", function(module, exports) {

$parcel$export(module.exports, "getWRMStats", () => $ded9e1e9d1d49fea$export$d2d916ddd03b82bc);
const $ded9e1e9d1d49fea$export$d2d916ddd03b82bc = ()=>{
    const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
    return {
        wrmStats: wrmStats
    };
};

});


parcelRegister("8a2x3", function(module, exports) {

$parcel$export(module.exports, "featureFlagsAddedToEVERYJiraEvent", () => $5cdd53b8b5c0bdde$export$8f6204c7f33d9925);
// by adding feature flag to this array you agree that this feature flag:
// * is expected to impact all performance metrics in Jira (page load, interactions, etc)
// * is expected to be short term
const $5cdd53b8b5c0bdde$export$8f6204c7f33d9925 = [];

});

parcelRegister("1AO5V", function(module, exports) {

$parcel$export(module.exports, "featureFlagsAddedToEVERYPageLoadEvent", () => $4a17eed3d0ef2849$export$85fd4da798ef108b);
// by adding feature flag to this array you agree that this feature flag:
// * is expected to impact *all page load* performance metrics in Jira
// * is expected to be short term
const $4a17eed3d0ef2849$export$85fd4da798ef108b = [
    'jsw-classic-override-force-consistency-after-issue-create',
    'bm3.emit-on-raf.top-experiences'
];

});

parcelRegister("4230y", function(module, exports) {

$parcel$export(module.exports, "jfpPerfFeatureFlags", () => $6b02f0cb1cbf5eec$export$b1f8075e4696e880);
const $6b02f0cb1cbf5eec$export$b1f8075e4696e880 = [
    // <jlane>
    'delorean.fix-locale-formats',
    // </jlane>
    // <ldurkan>
    // </ldurkan>
    // <molejniczak>
    // </molejniczak>
    // <etimothy>
    // </etimothy>
    // <lcaseiro>
    // </lcaseiro>
    // <zzheng>
    // </zzheng>
    // <lma>
    // </lma>
    // <ccarloni>
    // </ccarloni>
    // <agasparin>
    'fe.platform.error.tracking.enabled',
    // </agasparin>
    // <mbiniek>
    // </mbiniek>
    // <yvovk>
    'independent-bump-button-bento_6a9fd',
    // </yvovk>
    // <bduffin>
    // </bduffin>
    // <atay>
    // </atay>
    // <gotham>
    'issue-view-config-type-cleanup-enabled_mz6ah',
    // </gotham>
    // <nhiebl>
    'ptc.organization-id.fetch.enabled'
];

});

parcelRegister("cq4ut", function(module, exports) {

$parcel$export(module.exports, "getLighthouseMetrics", () => $32f59efe25d6f208$export$b46cecdf698e4bb5);

var $fCd5p = parcelRequire("fCd5p");

var $l2Evh = parcelRequire("l2Evh");

var $aozJ7 = parcelRequire("aozJ7");

var $d17m0 = parcelRequire("d17m0");

var $giMpj = parcelRequire("giMpj");
const $32f59efe25d6f208$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $aozJ7.getTBT)(start, stop, (0, $d17m0.EntriesBuffer)[(0, $l2Evh.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $fCd5p.getCLS)(start, stop, (0, $d17m0.EntriesBuffer)[(0, $l2Evh.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("fCd5p", function(module, exports) {

$parcel$export(module.exports, "getCLS", () => $827f21a764faf5b3$export$fc6227831ee7c7);
const $827f21a764faf5b3$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("l2Evh", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $6492440cd5bf8dc7$export$a4def92db6fc8e17);
const $6492440cd5bf8dc7$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("aozJ7", function(module, exports) {

$parcel$export(module.exports, "getTBT", () => $30ea5832be8cd3d8$export$2d6e933b35bd3407);
const $30ea5832be8cd3d8$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $30ea5832be8cd3d8$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $30ea5832be8cd3d8$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $30ea5832be8cd3d8$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $30ea5832be8cd3d8$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("d17m0", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", () => $d7d8f5c56069f3fd$export$f7dc16cbd16f7bbe);

var $l2Evh = parcelRequire("l2Evh");
class $d7d8f5c56069f3fd$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $d7d8f5c56069f3fd$export$f7dc16cbd16f7bbe = {
    [(0, $l2Evh.PerformanceObserverEntryTypes).LongTask]: new $d7d8f5c56069f3fd$export$2c6e86519c9e8188(),
    [(0, $l2Evh.PerformanceObserverEntryTypes).LayoutShift]: new $d7d8f5c56069f3fd$export$2c6e86519c9e8188()
};

});

parcelRegister("giMpj", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", () => $3364c446f0342fb8$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $3364c446f0342fb8$export$54fb8b6aaf70ec9c);

var $l2Evh = parcelRequire("l2Evh");

var $d17m0 = parcelRequire("d17m0");
let $3364c446f0342fb8$var$pe = null;
const $3364c446f0342fb8$var$getObserver = ()=>{
    if ($3364c446f0342fb8$var$pe !== null) return $3364c446f0342fb8$var$pe;
    $3364c446f0342fb8$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $l2Evh.PerformanceObserverEntryTypes).LayoutShift) (0, $d17m0.EntriesBuffer)[(0, $l2Evh.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $l2Evh.PerformanceObserverEntryTypes).LongTask) (0, $d17m0.EntriesBuffer)[(0, $l2Evh.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $3364c446f0342fb8$var$pe;
};
const $3364c446f0342fb8$export$768ccc3ab7bac3ea = ()=>{
    $3364c446f0342fb8$var$getObserver().observe({
        type: (0, $l2Evh.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $3364c446f0342fb8$export$54fb8b6aaf70ec9c = ()=>{
    $3364c446f0342fb8$var$getObserver().observe({
        type: (0, $l2Evh.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});


parcelRegister("7tRvw", function(module, exports) {

$parcel$export(module.exports, "ssr", () => $e26c009eb0c2973b$export$ea2375f6c0c9ffdc);
$parcel$export(module.exports, "ssrExtended", () => $e26c009eb0c2973b$export$b821aa3bb9044abf);

var $5iWql = parcelRequire("5iWql");

var $6rW04 = parcelRequire("6rW04");

var $RMoAZ = parcelRequire("RMoAZ");

var $grYTf = parcelRequire("grYTf");
const $e26c009eb0c2973b$var$getSSRFeatureFlags = (0, $5iWql.default)(()=>{
    try {
        const metaTagValue = (0, $6rW04.default)('spa-service-flags');
        if (metaTagValue === null) return null;
        return JSON.parse(metaTagValue) || null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
});
const $e26c009eb0c2973b$export$ea2375f6c0c9ffdc = {
    getDoneMark: (0, $RMoAZ.getSSRMark),
    getTimings: (0, $grYTf.getSSRTimings),
    getFeatureFlags: $e26c009eb0c2973b$var$getSSRFeatureFlags
};
const $e26c009eb0c2973b$export$b821aa3bb9044abf = {
    ...$e26c009eb0c2973b$export$ea2375f6c0c9ffdc,
    includeFeatureFlags: 'when-available'
};

});
parcelRegister("grYTf", function(module, exports) {

$parcel$export(module.exports, "getSSRTimings", () => $b236e9658e441dc3$export$bf7408e83532dcd0);

var $kd0cS = parcelRequire("kd0cS");
const $b236e9658e441dc3$export$bf7408e83532dcd0 = ()=>{
    if (!window.SPA_STATE) return null;
    const detailRenderTrace = window.SPA_STATE['ssr/detail_render_trace'];
    const detailRequestTrace = window.SPA_STATE['ssr/detail_request_trace'];
    const highLevelMetrics = window.SPA_STATE['ssr/metrics'];
    const timings = (0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(detailRenderTrace?.data?.traces) || {};
    if (highLevelMetrics?.data) {
        if ('ssrTotal' in highLevelMetrics.data) timings.total = {
            startTime: 0,
            duration: highLevelMetrics.data.ssrTotal
        };
        if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
            startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
            duration: highLevelMetrics.data.ssrGetStyle
        };
        if ('ssrPrefetch' in highLevelMetrics.data) {
            const prefetchStartTime = Object.values(detailRenderTrace?.data?.traces || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
            timings.prefetch = {
                startTime: prefetchStartTime,
                duration: highLevelMetrics.data.ssrPrefetch
            };
        }
    }
    if (detailRequestTrace?.data) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
        timings[`prefetch/${key}`] = value;
    });
    return timings;
};

});



// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$e9c56aa3b027d98f = 'jira-customer-service';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';

const $2e44694ecdbcd145$export$881d135f98d8d7d0 = 100;
const $2e44694ecdbcd145$export$9ab5bdcb8a1d6c34 = false;
const $2e44694ecdbcd145$export$12c1dc38ea1692da = 0;


$parcel$global.rlb("1QYl5")
//# sourceMappingURL=shared~commons~ar.3f0d9a63.js.map
